/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as WarehouseRouteRouteImport } from './routes/warehouse/route'
import { Route as SourceTemplatesRouteRouteImport } from './routes/source-templates/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as JobsRouteRouteImport } from './routes/jobs/route'
import { Route as IntegrationsRouteRouteImport } from './routes/integrations/route'
import { Route as FigmaRouteRouteImport } from './routes/figma/route'
import { Route as ExperimentsRouteRouteImport } from './routes/experiments/route'
import { Route as DraftExperimentsRouteRouteImport } from './routes/draft-experiments/route'
import { Route as ContentRouteRouteImport } from './routes/content/route'
import { Route as ApiKeysRouteRouteImport } from './routes/api-keys/route'
import { Route as AgentsRouteRouteImport } from './routes/agents/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WarehouseIndexRouteImport } from './routes/warehouse/index'
import { Route as SourceTemplatesIndexRouteImport } from './routes/source-templates/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as FigmaIndexRouteImport } from './routes/figma/index'
import { Route as ExperimentsIndexRouteImport } from './routes/experiments/index'
import { Route as DraftExperimentsIndexRouteImport } from './routes/draft-experiments/index'
import { Route as ContentIndexRouteImport } from './routes/content/index'
import { Route as ApiKeysIndexRouteImport } from './routes/api-keys/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as WarehouseSourceTablesRouteRouteImport } from './routes/warehouse/source-tables/route'
import { Route as WarehouseOverviewRouteRouteImport } from './routes/warehouse/overview/route'
import { Route as WarehouseMetricsRouteRouteImport } from './routes/warehouse/metrics/route'
import { Route as WarehouseIdTypesRouteRouteImport } from './routes/warehouse/id-types/route'
import { Route as WarehouseFeaturesRouteRouteImport } from './routes/warehouse/features/route'
import { Route as ExperimentsIdRouteRouteImport } from './routes/experiments/$id/route'
import { Route as DraftExperimentsIdRouteRouteImport } from './routes/draft-experiments/$id/route'
import { Route as ContentVariablesRouteRouteImport } from './routes/content/variables/route'
import { Route as ContentTemplatesRouteRouteImport } from './routes/content/templates/route'
import { Route as ContentStylesRouteRouteImport } from './routes/content/styles/route'
import { Route as ContentSchemasRouteRouteImport } from './routes/content/schemas/route'
import { Route as ContentRulesRouteRouteImport } from './routes/content/rules/route'
import { Route as ContentEvaluatorRouteRouteImport } from './routes/content/evaluator/route'
import { Route as ContentEvaluationRouteRouteImport } from './routes/content/evaluation/route'
import { Route as AgentsFigmaConvertRouteRouteImport } from './routes/agents/figma-convert/route'
import { Route as WarehouseSourceTablesIndexRouteImport } from './routes/warehouse/source-tables/index'
import { Route as WarehouseOverviewIndexRouteImport } from './routes/warehouse/overview/index'
import { Route as WarehouseMetricsIndexRouteImport } from './routes/warehouse/metrics/index'
import { Route as WarehouseIdTypesIndexRouteImport } from './routes/warehouse/id-types/index'
import { Route as WarehouseFeaturesIndexRouteImport } from './routes/warehouse/features/index'
import { Route as SettingsTeamIndexRouteImport } from './routes/settings/team/index'
import { Route as DraftExperimentsIdIndexRouteImport } from './routes/draft-experiments/$id/index'
import { Route as ContentVariablesIndexRouteImport } from './routes/content/variables/index'
import { Route as ContentTemplatesIndexRouteImport } from './routes/content/templates/index'
import { Route as ContentStylesIndexRouteImport } from './routes/content/styles/index'
import { Route as ContentSchemasIndexRouteImport } from './routes/content/schemas/index'
import { Route as ContentRulesIndexRouteImport } from './routes/content/rules/index'
import { Route as ContentEvaluatorIndexRouteImport } from './routes/content/evaluator/index'
import { Route as ContentEvaluationIndexRouteImport } from './routes/content/evaluation/index'
import { Route as AgentsFigmaConvertIndexRouteImport } from './routes/agents/figma-convert/index'
import { Route as ContentTemplatesNewRouteImport } from './routes/content/templates/new'
import { Route as AgentsFigmaConvertHistoryRouteImport } from './routes/agents/figma-convert/history'
import { Route as ExperimentsIdVariantsRouteRouteImport } from './routes/experiments/$id/variants/route'
import { Route as ContentVariablesTypeIdRouteRouteImport } from './routes/content/variables/$typeId/route'
import { Route as ContentRulesGroupsRouteRouteImport } from './routes/content/rules/groups/route'
import { Route as DraftExperimentsIdReviewIndexRouteImport } from './routes/draft-experiments/$id/review/index'
import { Route as ContentVariablesTypeIdIndexRouteImport } from './routes/content/variables/$typeId/index'
import { Route as ContentRulesGroupsIndexRouteImport } from './routes/content/rules/groups/index'
import { Route as DraftExperimentsIdVariantsVariantIdEditRouteImport } from './routes/draft-experiments/$id/variants/$variantId/edit'
import { Route as DraftExperimentsIdReviewVariantsVariantIdRouteRouteImport } from './routes/draft-experiments/$id/review/variants/$variantId/route'
import { Route as DraftExperimentsIdGenerationVariantsVariantIdRouteRouteImport } from './routes/draft-experiments/$id/generation/variants/$variantId/route'
import { Route as DraftExperimentsIdReviewVariantsVariantIdIndexRouteImport } from './routes/draft-experiments/$id/review/variants/$variantId/index'
import { Route as DraftExperimentsIdGenerationVariantsVariantIdIndexRouteImport } from './routes/draft-experiments/$id/generation/variants/$variantId/index'
import { Route as DraftExperimentsIdReviewVariantsVariantIdTabRouteImport } from './routes/draft-experiments/$id/review/variants/$variantId/$tab'
import { Route as DraftExperimentsIdGenerationVariantsVariantIdTabRouteImport } from './routes/draft-experiments/$id/generation/variants/$variantId/$tab'

const WarehouseSourceTablesNewLazyRouteImport = createFileRoute(
  '/warehouse/source-tables/new',
)()
const WarehouseSourceTablesSourceTableIdLazyRouteImport = createFileRoute(
  '/warehouse/source-tables/$sourceTableId',
)()
const WarehouseMetricsNewLazyRouteImport = createFileRoute(
  '/warehouse/metrics/new',
)()
const WarehouseMetricsMetricIdLazyRouteImport = createFileRoute(
  '/warehouse/metrics/$metricId',
)()
const WarehouseIdTypesNewLazyRouteImport = createFileRoute(
  '/warehouse/id-types/new',
)()
const WarehouseIdTypesIdTypeIdLazyRouteImport = createFileRoute(
  '/warehouse/id-types/$idTypeId',
)()
const WarehouseFeaturesNewLazyRouteImport = createFileRoute(
  '/warehouse/features/new',
)()
const WarehouseFeaturesFeatureIdLazyRouteImport = createFileRoute(
  '/warehouse/features/$featureId',
)()
const ExperimentsIdSetupLazyRouteImport = createFileRoute(
  '/experiments/$id/setup',
)()
const ExperimentsIdResultsLazyRouteImport = createFileRoute(
  '/experiments/$id/results',
)()
const ExperimentsIdDiagnosticsLazyRouteImport = createFileRoute(
  '/experiments/$id/diagnostics',
)()
const ExperimentsIdControlLazyRouteImport = createFileRoute(
  '/experiments/$id/control',
)()
const DraftExperimentsIdSetupLazyRouteImport = createFileRoute(
  '/draft-experiments/$id/setup',
)()
const ContentVariablesNewLazyRouteImport = createFileRoute(
  '/content/variables/new',
)()
const ContentTemplatesTemplateIdLazyRouteImport = createFileRoute(
  '/content/templates/$templateId',
)()
const ContentStylesNewLazyRouteImport = createFileRoute('/content/styles/new')()
const ContentStylesStyleIdLazyRouteImport = createFileRoute(
  '/content/styles/$styleId',
)()
const ContentSchemasNewLazyRouteImport = createFileRoute(
  '/content/schemas/new',
)()
const ContentSchemasSchemaIdLazyRouteImport = createFileRoute(
  '/content/schemas/$schemaId',
)()
const ContentRulesNewLazyRouteImport = createFileRoute('/content/rules/new')()
const ContentRulesRuleIdLazyRouteImport = createFileRoute(
  '/content/rules/$ruleId',
)()
const ExperimentsIdVariantsIndexLazyRouteImport = createFileRoute(
  '/experiments/$id/variants/',
)()
const DraftExperimentsIdGenerationIndexLazyRouteImport = createFileRoute(
  '/draft-experiments/$id/generation/',
)()
const ExperimentsIdVariantsNewLazyRouteImport = createFileRoute(
  '/experiments/$id/variants/new',
)()
const ContentVariablesTypeIdValuesLazyRouteImport = createFileRoute(
  '/content/variables/$typeId/values',
)()
const ContentVariablesTypeIdStructureLazyRouteImport = createFileRoute(
  '/content/variables/$typeId/structure',
)()
const ContentRulesGroupsNewLazyRouteImport = createFileRoute(
  '/content/rules/groups/new',
)()
const ContentRulesGroupsGroupIdLazyRouteImport = createFileRoute(
  '/content/rules/groups/$groupId',
)()
const ExperimentsIdVariantsVariantIdEditLazyRouteImport = createFileRoute(
  '/experiments/$id/variants/$variantId/edit',
)()

const WarehouseRouteRoute = WarehouseRouteRouteImport.update({
  id: '/warehouse',
  path: '/warehouse',
  getParentRoute: () => rootRouteImport,
} as any)
const SourceTemplatesRouteRoute = SourceTemplatesRouteRouteImport.update({
  id: '/source-templates',
  path: '/source-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRouteRoute = JobsRouteRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRouteRoute = IntegrationsRouteRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const FigmaRouteRoute = FigmaRouteRouteImport.update({
  id: '/figma',
  path: '/figma',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsRouteRoute = ExperimentsRouteRouteImport.update({
  id: '/experiments',
  path: '/experiments',
  getParentRoute: () => rootRouteImport,
} as any)
const DraftExperimentsRouteRoute = DraftExperimentsRouteRouteImport.update({
  id: '/draft-experiments',
  path: '/draft-experiments',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentRouteRoute = ContentRouteRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRouteRoute = ApiKeysRouteRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRouteRoute = AgentsRouteRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WarehouseIndexRoute = WarehouseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehouseRouteRoute,
} as any)
const SourceTemplatesIndexRoute = SourceTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SourceTemplatesRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JobsRouteRoute,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IntegrationsRouteRoute,
} as any)
const FigmaIndexRoute = FigmaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FigmaRouteRoute,
} as any)
const ExperimentsIndexRoute = ExperimentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExperimentsRouteRoute,
} as any)
const DraftExperimentsIndexRoute = DraftExperimentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DraftExperimentsRouteRoute,
} as any)
const ContentIndexRoute = ContentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ApiKeysIndexRoute = ApiKeysIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApiKeysRouteRoute,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const WarehouseSourceTablesRouteRoute =
  WarehouseSourceTablesRouteRouteImport.update({
    id: '/source-tables',
    path: '/source-tables',
    getParentRoute: () => WarehouseRouteRoute,
  } as any)
const WarehouseOverviewRouteRoute = WarehouseOverviewRouteRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => WarehouseRouteRoute,
} as any)
const WarehouseMetricsRouteRoute = WarehouseMetricsRouteRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => WarehouseRouteRoute,
} as any)
const WarehouseIdTypesRouteRoute = WarehouseIdTypesRouteRouteImport.update({
  id: '/id-types',
  path: '/id-types',
  getParentRoute: () => WarehouseRouteRoute,
} as any)
const WarehouseFeaturesRouteRoute = WarehouseFeaturesRouteRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => WarehouseRouteRoute,
} as any)
const ExperimentsIdRouteRoute = ExperimentsIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ExperimentsRouteRoute,
} as any)
const DraftExperimentsIdRouteRoute = DraftExperimentsIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DraftExperimentsRouteRoute,
} as any)
const ContentVariablesRouteRoute = ContentVariablesRouteRouteImport.update({
  id: '/variables',
  path: '/variables',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentTemplatesRouteRoute = ContentTemplatesRouteRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentStylesRouteRoute = ContentStylesRouteRouteImport.update({
  id: '/styles',
  path: '/styles',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentSchemasRouteRoute = ContentSchemasRouteRouteImport.update({
  id: '/schemas',
  path: '/schemas',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentRulesRouteRoute = ContentRulesRouteRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentEvaluatorRouteRoute = ContentEvaluatorRouteRouteImport.update({
  id: '/evaluator',
  path: '/evaluator',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentEvaluationRouteRoute = ContentEvaluationRouteRouteImport.update({
  id: '/evaluation',
  path: '/evaluation',
  getParentRoute: () => ContentRouteRoute,
} as any)
const AgentsFigmaConvertRouteRoute = AgentsFigmaConvertRouteRouteImport.update({
  id: '/figma-convert',
  path: '/figma-convert',
  getParentRoute: () => AgentsRouteRoute,
} as any)
const WarehouseSourceTablesIndexRoute =
  WarehouseSourceTablesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WarehouseSourceTablesRouteRoute,
  } as any)
const WarehouseOverviewIndexRoute = WarehouseOverviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehouseOverviewRouteRoute,
} as any)
const WarehouseMetricsIndexRoute = WarehouseMetricsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehouseMetricsRouteRoute,
} as any)
const WarehouseIdTypesIndexRoute = WarehouseIdTypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehouseIdTypesRouteRoute,
} as any)
const WarehouseFeaturesIndexRoute = WarehouseFeaturesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehouseFeaturesRouteRoute,
} as any)
const SettingsTeamIndexRoute = SettingsTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const DraftExperimentsIdIndexRoute = DraftExperimentsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DraftExperimentsIdRouteRoute,
} as any)
const ContentVariablesIndexRoute = ContentVariablesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentVariablesRouteRoute,
} as any)
const ContentTemplatesIndexRoute = ContentTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentTemplatesRouteRoute,
} as any)
const ContentStylesIndexRoute = ContentStylesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentStylesRouteRoute,
} as any)
const ContentSchemasIndexRoute = ContentSchemasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentSchemasRouteRoute,
} as any)
const ContentRulesIndexRoute = ContentRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentRulesRouteRoute,
} as any)
const ContentEvaluatorIndexRoute = ContentEvaluatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentEvaluatorRouteRoute,
} as any)
const ContentEvaluationIndexRoute = ContentEvaluationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentEvaluationRouteRoute,
} as any)
const AgentsFigmaConvertIndexRoute = AgentsFigmaConvertIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsFigmaConvertRouteRoute,
} as any)
const WarehouseSourceTablesNewLazyRoute =
  WarehouseSourceTablesNewLazyRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => WarehouseSourceTablesRouteRoute,
  } as any).lazy(() =>
    import('./routes/warehouse/source-tables/new.lazy').then((d) => d.Route),
  )
const WarehouseSourceTablesSourceTableIdLazyRoute =
  WarehouseSourceTablesSourceTableIdLazyRouteImport.update({
    id: '/$sourceTableId',
    path: '/$sourceTableId',
    getParentRoute: () => WarehouseSourceTablesRouteRoute,
  } as any).lazy(() =>
    import('./routes/warehouse/source-tables/$sourceTableId.lazy').then(
      (d) => d.Route,
    ),
  )
const WarehouseMetricsNewLazyRoute = WarehouseMetricsNewLazyRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WarehouseMetricsRouteRoute,
} as any).lazy(() =>
  import('./routes/warehouse/metrics/new.lazy').then((d) => d.Route),
)
const WarehouseMetricsMetricIdLazyRoute =
  WarehouseMetricsMetricIdLazyRouteImport.update({
    id: '/$metricId',
    path: '/$metricId',
    getParentRoute: () => WarehouseMetricsRouteRoute,
  } as any).lazy(() =>
    import('./routes/warehouse/metrics/$metricId.lazy').then((d) => d.Route),
  )
const WarehouseIdTypesNewLazyRoute = WarehouseIdTypesNewLazyRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WarehouseIdTypesRouteRoute,
} as any).lazy(() =>
  import('./routes/warehouse/id-types/new.lazy').then((d) => d.Route),
)
const WarehouseIdTypesIdTypeIdLazyRoute =
  WarehouseIdTypesIdTypeIdLazyRouteImport.update({
    id: '/$idTypeId',
    path: '/$idTypeId',
    getParentRoute: () => WarehouseIdTypesRouteRoute,
  } as any).lazy(() =>
    import('./routes/warehouse/id-types/$idTypeId.lazy').then((d) => d.Route),
  )
const WarehouseFeaturesNewLazyRoute =
  WarehouseFeaturesNewLazyRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => WarehouseFeaturesRouteRoute,
  } as any).lazy(() =>
    import('./routes/warehouse/features/new.lazy').then((d) => d.Route),
  )
const WarehouseFeaturesFeatureIdLazyRoute =
  WarehouseFeaturesFeatureIdLazyRouteImport.update({
    id: '/$featureId',
    path: '/$featureId',
    getParentRoute: () => WarehouseFeaturesRouteRoute,
  } as any).lazy(() =>
    import('./routes/warehouse/features/$featureId.lazy').then((d) => d.Route),
  )
const ExperimentsIdSetupLazyRoute = ExperimentsIdSetupLazyRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => ExperimentsIdRouteRoute,
} as any).lazy(() =>
  import('./routes/experiments/$id/setup.lazy').then((d) => d.Route),
)
const ExperimentsIdResultsLazyRoute =
  ExperimentsIdResultsLazyRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => ExperimentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/experiments/$id/results.lazy').then((d) => d.Route),
  )
const ExperimentsIdDiagnosticsLazyRoute =
  ExperimentsIdDiagnosticsLazyRouteImport.update({
    id: '/diagnostics',
    path: '/diagnostics',
    getParentRoute: () => ExperimentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/experiments/$id/diagnostics.lazy').then((d) => d.Route),
  )
const ExperimentsIdControlLazyRoute =
  ExperimentsIdControlLazyRouteImport.update({
    id: '/control',
    path: '/control',
    getParentRoute: () => ExperimentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/experiments/$id/control.lazy').then((d) => d.Route),
  )
const DraftExperimentsIdSetupLazyRoute =
  DraftExperimentsIdSetupLazyRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => DraftExperimentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/draft-experiments/$id/setup.lazy').then((d) => d.Route),
  )
const ContentVariablesNewLazyRoute = ContentVariablesNewLazyRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ContentVariablesRouteRoute,
} as any).lazy(() =>
  import('./routes/content/variables/new.lazy').then((d) => d.Route),
)
const ContentTemplatesTemplateIdLazyRoute =
  ContentTemplatesTemplateIdLazyRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => ContentTemplatesRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/templates/$templateId.lazy').then((d) => d.Route),
  )
const ContentStylesNewLazyRoute = ContentStylesNewLazyRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ContentStylesRouteRoute,
} as any).lazy(() =>
  import('./routes/content/styles/new.lazy').then((d) => d.Route),
)
const ContentStylesStyleIdLazyRoute =
  ContentStylesStyleIdLazyRouteImport.update({
    id: '/$styleId',
    path: '/$styleId',
    getParentRoute: () => ContentStylesRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/styles/$styleId.lazy').then((d) => d.Route),
  )
const ContentSchemasNewLazyRoute = ContentSchemasNewLazyRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ContentSchemasRouteRoute,
} as any).lazy(() =>
  import('./routes/content/schemas/new.lazy').then((d) => d.Route),
)
const ContentSchemasSchemaIdLazyRoute =
  ContentSchemasSchemaIdLazyRouteImport.update({
    id: '/$schemaId',
    path: '/$schemaId',
    getParentRoute: () => ContentSchemasRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/schemas/$schemaId.lazy').then((d) => d.Route),
  )
const ContentRulesNewLazyRoute = ContentRulesNewLazyRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ContentRulesRouteRoute,
} as any).lazy(() =>
  import('./routes/content/rules/new.lazy').then((d) => d.Route),
)
const ContentRulesRuleIdLazyRoute = ContentRulesRuleIdLazyRouteImport.update({
  id: '/$ruleId',
  path: '/$ruleId',
  getParentRoute: () => ContentRulesRouteRoute,
} as any).lazy(() =>
  import('./routes/content/rules/$ruleId.lazy').then((d) => d.Route),
)
const ContentTemplatesNewRoute = ContentTemplatesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ContentTemplatesRouteRoute,
} as any)
const AgentsFigmaConvertHistoryRoute =
  AgentsFigmaConvertHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AgentsFigmaConvertRouteRoute,
  } as any)
const ExperimentsIdVariantsRouteRoute =
  ExperimentsIdVariantsRouteRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => ExperimentsIdRouteRoute,
  } as any)
const ContentVariablesTypeIdRouteRoute =
  ContentVariablesTypeIdRouteRouteImport.update({
    id: '/$typeId',
    path: '/$typeId',
    getParentRoute: () => ContentVariablesRouteRoute,
  } as any)
const ContentRulesGroupsRouteRoute = ContentRulesGroupsRouteRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => ContentRulesRouteRoute,
} as any)
const ExperimentsIdVariantsIndexLazyRoute =
  ExperimentsIdVariantsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ExperimentsIdVariantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/experiments/$id/variants/index.lazy').then((d) => d.Route),
  )
const DraftExperimentsIdGenerationIndexLazyRoute =
  DraftExperimentsIdGenerationIndexLazyRouteImport.update({
    id: '/generation/',
    path: '/generation/',
    getParentRoute: () => DraftExperimentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/draft-experiments/$id/generation/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DraftExperimentsIdReviewIndexRoute =
  DraftExperimentsIdReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => DraftExperimentsIdRouteRoute,
  } as any)
const ContentVariablesTypeIdIndexRoute =
  ContentVariablesTypeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContentVariablesTypeIdRouteRoute,
  } as any)
const ContentRulesGroupsIndexRoute = ContentRulesGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentRulesGroupsRouteRoute,
} as any)
const ExperimentsIdVariantsNewLazyRoute =
  ExperimentsIdVariantsNewLazyRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ExperimentsIdVariantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/experiments/$id/variants/new.lazy').then((d) => d.Route),
  )
const ContentVariablesTypeIdValuesLazyRoute =
  ContentVariablesTypeIdValuesLazyRouteImport.update({
    id: '/values',
    path: '/values',
    getParentRoute: () => ContentVariablesTypeIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/variables/$typeId/values.lazy').then(
      (d) => d.Route,
    ),
  )
const ContentVariablesTypeIdStructureLazyRoute =
  ContentVariablesTypeIdStructureLazyRouteImport.update({
    id: '/structure',
    path: '/structure',
    getParentRoute: () => ContentVariablesTypeIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/variables/$typeId/structure.lazy').then(
      (d) => d.Route,
    ),
  )
const ContentRulesGroupsNewLazyRoute =
  ContentRulesGroupsNewLazyRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ContentRulesGroupsRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/rules/groups/new.lazy').then((d) => d.Route),
  )
const ContentRulesGroupsGroupIdLazyRoute =
  ContentRulesGroupsGroupIdLazyRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => ContentRulesGroupsRouteRoute,
  } as any).lazy(() =>
    import('./routes/content/rules/groups/$groupId.lazy').then((d) => d.Route),
  )
const ExperimentsIdVariantsVariantIdEditLazyRoute =
  ExperimentsIdVariantsVariantIdEditLazyRouteImport.update({
    id: '/$variantId/edit',
    path: '/$variantId/edit',
    getParentRoute: () => ExperimentsIdVariantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/experiments/$id/variants/$variantId/edit.lazy').then(
      (d) => d.Route,
    ),
  )
const DraftExperimentsIdVariantsVariantIdEditRoute =
  DraftExperimentsIdVariantsVariantIdEditRouteImport.update({
    id: '/variants/$variantId/edit',
    path: '/variants/$variantId/edit',
    getParentRoute: () => DraftExperimentsIdRouteRoute,
  } as any)
const DraftExperimentsIdReviewVariantsVariantIdRouteRoute =
  DraftExperimentsIdReviewVariantsVariantIdRouteRouteImport.update({
    id: '/review/variants/$variantId',
    path: '/review/variants/$variantId',
    getParentRoute: () => DraftExperimentsIdRouteRoute,
  } as any)
const DraftExperimentsIdGenerationVariantsVariantIdRouteRoute =
  DraftExperimentsIdGenerationVariantsVariantIdRouteRouteImport.update({
    id: '/generation/variants/$variantId',
    path: '/generation/variants/$variantId',
    getParentRoute: () => DraftExperimentsIdRouteRoute,
  } as any)
const DraftExperimentsIdReviewVariantsVariantIdIndexRoute =
  DraftExperimentsIdReviewVariantsVariantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DraftExperimentsIdReviewVariantsVariantIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/draft-experiments/$id/review/variants/$variantId/index.lazy'
    ).then((d) => d.Route),
  )
const DraftExperimentsIdGenerationVariantsVariantIdIndexRoute =
  DraftExperimentsIdGenerationVariantsVariantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DraftExperimentsIdGenerationVariantsVariantIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/draft-experiments/$id/generation/variants/$variantId/index.lazy'
    ).then((d) => d.Route),
  )
const DraftExperimentsIdReviewVariantsVariantIdTabRoute =
  DraftExperimentsIdReviewVariantsVariantIdTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => DraftExperimentsIdReviewVariantsVariantIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/draft-experiments/$id/review/variants/$variantId/$tab.lazy'
    ).then((d) => d.Route),
  )
const DraftExperimentsIdGenerationVariantsVariantIdTabRoute =
  DraftExperimentsIdGenerationVariantsVariantIdTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () =>
      DraftExperimentsIdGenerationVariantsVariantIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/draft-experiments/$id/generation/variants/$variantId/$tab.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRouteRouteWithChildren
  '/api-keys': typeof ApiKeysRouteRouteWithChildren
  '/content': typeof ContentRouteRouteWithChildren
  '/draft-experiments': typeof DraftExperimentsRouteRouteWithChildren
  '/experiments': typeof ExperimentsRouteRouteWithChildren
  '/figma': typeof FigmaRouteRouteWithChildren
  '/integrations': typeof IntegrationsRouteRouteWithChildren
  '/jobs': typeof JobsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/source-templates': typeof SourceTemplatesRouteRouteWithChildren
  '/warehouse': typeof WarehouseRouteRouteWithChildren
  '/agents/figma-convert': typeof AgentsFigmaConvertRouteRouteWithChildren
  '/content/evaluation': typeof ContentEvaluationRouteRouteWithChildren
  '/content/evaluator': typeof ContentEvaluatorRouteRouteWithChildren
  '/content/rules': typeof ContentRulesRouteRouteWithChildren
  '/content/schemas': typeof ContentSchemasRouteRouteWithChildren
  '/content/styles': typeof ContentStylesRouteRouteWithChildren
  '/content/templates': typeof ContentTemplatesRouteRouteWithChildren
  '/content/variables': typeof ContentVariablesRouteRouteWithChildren
  '/draft-experiments/$id': typeof DraftExperimentsIdRouteRouteWithChildren
  '/experiments/$id': typeof ExperimentsIdRouteRouteWithChildren
  '/warehouse/features': typeof WarehouseFeaturesRouteRouteWithChildren
  '/warehouse/id-types': typeof WarehouseIdTypesRouteRouteWithChildren
  '/warehouse/metrics': typeof WarehouseMetricsRouteRouteWithChildren
  '/warehouse/overview': typeof WarehouseOverviewRouteRouteWithChildren
  '/warehouse/source-tables': typeof WarehouseSourceTablesRouteRouteWithChildren
  '/agents/': typeof AgentsIndexRoute
  '/api-keys/': typeof ApiKeysIndexRoute
  '/content/': typeof ContentIndexRoute
  '/draft-experiments/': typeof DraftExperimentsIndexRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/figma/': typeof FigmaIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/source-templates/': typeof SourceTemplatesIndexRoute
  '/warehouse/': typeof WarehouseIndexRoute
  '/content/rules/groups': typeof ContentRulesGroupsRouteRouteWithChildren
  '/content/variables/$typeId': typeof ContentVariablesTypeIdRouteRouteWithChildren
  '/experiments/$id/variants': typeof ExperimentsIdVariantsRouteRouteWithChildren
  '/agents/figma-convert/history': typeof AgentsFigmaConvertHistoryRoute
  '/content/templates/new': typeof ContentTemplatesNewRoute
  '/content/rules/$ruleId': typeof ContentRulesRuleIdLazyRoute
  '/content/rules/new': typeof ContentRulesNewLazyRoute
  '/content/schemas/$schemaId': typeof ContentSchemasSchemaIdLazyRoute
  '/content/schemas/new': typeof ContentSchemasNewLazyRoute
  '/content/styles/$styleId': typeof ContentStylesStyleIdLazyRoute
  '/content/styles/new': typeof ContentStylesNewLazyRoute
  '/content/templates/$templateId': typeof ContentTemplatesTemplateIdLazyRoute
  '/content/variables/new': typeof ContentVariablesNewLazyRoute
  '/draft-experiments/$id/setup': typeof DraftExperimentsIdSetupLazyRoute
  '/experiments/$id/control': typeof ExperimentsIdControlLazyRoute
  '/experiments/$id/diagnostics': typeof ExperimentsIdDiagnosticsLazyRoute
  '/experiments/$id/results': typeof ExperimentsIdResultsLazyRoute
  '/experiments/$id/setup': typeof ExperimentsIdSetupLazyRoute
  '/warehouse/features/$featureId': typeof WarehouseFeaturesFeatureIdLazyRoute
  '/warehouse/features/new': typeof WarehouseFeaturesNewLazyRoute
  '/warehouse/id-types/$idTypeId': typeof WarehouseIdTypesIdTypeIdLazyRoute
  '/warehouse/id-types/new': typeof WarehouseIdTypesNewLazyRoute
  '/warehouse/metrics/$metricId': typeof WarehouseMetricsMetricIdLazyRoute
  '/warehouse/metrics/new': typeof WarehouseMetricsNewLazyRoute
  '/warehouse/source-tables/$sourceTableId': typeof WarehouseSourceTablesSourceTableIdLazyRoute
  '/warehouse/source-tables/new': typeof WarehouseSourceTablesNewLazyRoute
  '/agents/figma-convert/': typeof AgentsFigmaConvertIndexRoute
  '/content/evaluation/': typeof ContentEvaluationIndexRoute
  '/content/evaluator/': typeof ContentEvaluatorIndexRoute
  '/content/rules/': typeof ContentRulesIndexRoute
  '/content/schemas/': typeof ContentSchemasIndexRoute
  '/content/styles/': typeof ContentStylesIndexRoute
  '/content/templates/': typeof ContentTemplatesIndexRoute
  '/content/variables/': typeof ContentVariablesIndexRoute
  '/draft-experiments/$id/': typeof DraftExperimentsIdIndexRoute
  '/settings/team': typeof SettingsTeamIndexRoute
  '/warehouse/features/': typeof WarehouseFeaturesIndexRoute
  '/warehouse/id-types/': typeof WarehouseIdTypesIndexRoute
  '/warehouse/metrics/': typeof WarehouseMetricsIndexRoute
  '/warehouse/overview/': typeof WarehouseOverviewIndexRoute
  '/warehouse/source-tables/': typeof WarehouseSourceTablesIndexRoute
  '/content/rules/groups/$groupId': typeof ContentRulesGroupsGroupIdLazyRoute
  '/content/rules/groups/new': typeof ContentRulesGroupsNewLazyRoute
  '/content/variables/$typeId/structure': typeof ContentVariablesTypeIdStructureLazyRoute
  '/content/variables/$typeId/values': typeof ContentVariablesTypeIdValuesLazyRoute
  '/experiments/$id/variants/new': typeof ExperimentsIdVariantsNewLazyRoute
  '/content/rules/groups/': typeof ContentRulesGroupsIndexRoute
  '/content/variables/$typeId/': typeof ContentVariablesTypeIdIndexRoute
  '/draft-experiments/$id/review': typeof DraftExperimentsIdReviewIndexRoute
  '/draft-experiments/$id/generation': typeof DraftExperimentsIdGenerationIndexLazyRoute
  '/experiments/$id/variants/': typeof ExperimentsIdVariantsIndexLazyRoute
  '/draft-experiments/$id/generation/variants/$variantId': typeof DraftExperimentsIdGenerationVariantsVariantIdRouteRouteWithChildren
  '/draft-experiments/$id/review/variants/$variantId': typeof DraftExperimentsIdReviewVariantsVariantIdRouteRouteWithChildren
  '/draft-experiments/$id/variants/$variantId/edit': typeof DraftExperimentsIdVariantsVariantIdEditRoute
  '/experiments/$id/variants/$variantId/edit': typeof ExperimentsIdVariantsVariantIdEditLazyRoute
  '/draft-experiments/$id/generation/variants/$variantId/$tab': typeof DraftExperimentsIdGenerationVariantsVariantIdTabRoute
  '/draft-experiments/$id/review/variants/$variantId/$tab': typeof DraftExperimentsIdReviewVariantsVariantIdTabRoute
  '/draft-experiments/$id/generation/variants/$variantId/': typeof DraftExperimentsIdGenerationVariantsVariantIdIndexRoute
  '/draft-experiments/$id/review/variants/$variantId/': typeof DraftExperimentsIdReviewVariantsVariantIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/experiments/$id': typeof ExperimentsIdRouteRouteWithChildren
  '/agents': typeof AgentsIndexRoute
  '/api-keys': typeof ApiKeysIndexRoute
  '/content': typeof ContentIndexRoute
  '/draft-experiments': typeof DraftExperimentsIndexRoute
  '/experiments': typeof ExperimentsIndexRoute
  '/figma': typeof FigmaIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/jobs': typeof JobsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/source-templates': typeof SourceTemplatesIndexRoute
  '/warehouse': typeof WarehouseIndexRoute
  '/agents/figma-convert/history': typeof AgentsFigmaConvertHistoryRoute
  '/content/templates/new': typeof ContentTemplatesNewRoute
  '/content/rules/$ruleId': typeof ContentRulesRuleIdLazyRoute
  '/content/rules/new': typeof ContentRulesNewLazyRoute
  '/content/schemas/$schemaId': typeof ContentSchemasSchemaIdLazyRoute
  '/content/schemas/new': typeof ContentSchemasNewLazyRoute
  '/content/styles/$styleId': typeof ContentStylesStyleIdLazyRoute
  '/content/styles/new': typeof ContentStylesNewLazyRoute
  '/content/templates/$templateId': typeof ContentTemplatesTemplateIdLazyRoute
  '/content/variables/new': typeof ContentVariablesNewLazyRoute
  '/draft-experiments/$id/setup': typeof DraftExperimentsIdSetupLazyRoute
  '/experiments/$id/control': typeof ExperimentsIdControlLazyRoute
  '/experiments/$id/diagnostics': typeof ExperimentsIdDiagnosticsLazyRoute
  '/experiments/$id/results': typeof ExperimentsIdResultsLazyRoute
  '/experiments/$id/setup': typeof ExperimentsIdSetupLazyRoute
  '/warehouse/features/$featureId': typeof WarehouseFeaturesFeatureIdLazyRoute
  '/warehouse/features/new': typeof WarehouseFeaturesNewLazyRoute
  '/warehouse/id-types/$idTypeId': typeof WarehouseIdTypesIdTypeIdLazyRoute
  '/warehouse/id-types/new': typeof WarehouseIdTypesNewLazyRoute
  '/warehouse/metrics/$metricId': typeof WarehouseMetricsMetricIdLazyRoute
  '/warehouse/metrics/new': typeof WarehouseMetricsNewLazyRoute
  '/warehouse/source-tables/$sourceTableId': typeof WarehouseSourceTablesSourceTableIdLazyRoute
  '/warehouse/source-tables/new': typeof WarehouseSourceTablesNewLazyRoute
  '/agents/figma-convert': typeof AgentsFigmaConvertIndexRoute
  '/content/evaluation': typeof ContentEvaluationIndexRoute
  '/content/evaluator': typeof ContentEvaluatorIndexRoute
  '/content/rules': typeof ContentRulesIndexRoute
  '/content/schemas': typeof ContentSchemasIndexRoute
  '/content/styles': typeof ContentStylesIndexRoute
  '/content/templates': typeof ContentTemplatesIndexRoute
  '/content/variables': typeof ContentVariablesIndexRoute
  '/draft-experiments/$id': typeof DraftExperimentsIdIndexRoute
  '/settings/team': typeof SettingsTeamIndexRoute
  '/warehouse/features': typeof WarehouseFeaturesIndexRoute
  '/warehouse/id-types': typeof WarehouseIdTypesIndexRoute
  '/warehouse/metrics': typeof WarehouseMetricsIndexRoute
  '/warehouse/overview': typeof WarehouseOverviewIndexRoute
  '/warehouse/source-tables': typeof WarehouseSourceTablesIndexRoute
  '/content/rules/groups/$groupId': typeof ContentRulesGroupsGroupIdLazyRoute
  '/content/rules/groups/new': typeof ContentRulesGroupsNewLazyRoute
  '/content/variables/$typeId/structure': typeof ContentVariablesTypeIdStructureLazyRoute
  '/content/variables/$typeId/values': typeof ContentVariablesTypeIdValuesLazyRoute
  '/experiments/$id/variants/new': typeof ExperimentsIdVariantsNewLazyRoute
  '/content/rules/groups': typeof ContentRulesGroupsIndexRoute
  '/content/variables/$typeId': typeof ContentVariablesTypeIdIndexRoute
  '/draft-experiments/$id/review': typeof DraftExperimentsIdReviewIndexRoute
  '/draft-experiments/$id/generation': typeof DraftExperimentsIdGenerationIndexLazyRoute
  '/experiments/$id/variants': typeof ExperimentsIdVariantsIndexLazyRoute
  '/draft-experiments/$id/variants/$variantId/edit': typeof DraftExperimentsIdVariantsVariantIdEditRoute
  '/experiments/$id/variants/$variantId/edit': typeof ExperimentsIdVariantsVariantIdEditLazyRoute
  '/draft-experiments/$id/generation/variants/$variantId/$tab': typeof DraftExperimentsIdGenerationVariantsVariantIdTabRoute
  '/draft-experiments/$id/review/variants/$variantId/$tab': typeof DraftExperimentsIdReviewVariantsVariantIdTabRoute
  '/draft-experiments/$id/generation/variants/$variantId': typeof DraftExperimentsIdGenerationVariantsVariantIdIndexRoute
  '/draft-experiments/$id/review/variants/$variantId': typeof DraftExperimentsIdReviewVariantsVariantIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agents': typeof AgentsRouteRouteWithChildren
  '/api-keys': typeof ApiKeysRouteRouteWithChildren
  '/content': typeof ContentRouteRouteWithChildren
  '/draft-experiments': typeof DraftExperimentsRouteRouteWithChildren
  '/experiments': typeof ExperimentsRouteRouteWithChildren
  '/figma': typeof FigmaRouteRouteWithChildren
  '/integrations': typeof IntegrationsRouteRouteWithChildren
  '/jobs': typeof JobsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/source-templates': typeof SourceTemplatesRouteRouteWithChildren
  '/warehouse': typeof WarehouseRouteRouteWithChildren
  '/agents/figma-convert': typeof AgentsFigmaConvertRouteRouteWithChildren
  '/content/evaluation': typeof ContentEvaluationRouteRouteWithChildren
  '/content/evaluator': typeof ContentEvaluatorRouteRouteWithChildren
  '/content/rules': typeof ContentRulesRouteRouteWithChildren
  '/content/schemas': typeof ContentSchemasRouteRouteWithChildren
  '/content/styles': typeof ContentStylesRouteRouteWithChildren
  '/content/templates': typeof ContentTemplatesRouteRouteWithChildren
  '/content/variables': typeof ContentVariablesRouteRouteWithChildren
  '/draft-experiments/$id': typeof DraftExperimentsIdRouteRouteWithChildren
  '/experiments/$id': typeof ExperimentsIdRouteRouteWithChildren
  '/warehouse/features': typeof WarehouseFeaturesRouteRouteWithChildren
  '/warehouse/id-types': typeof WarehouseIdTypesRouteRouteWithChildren
  '/warehouse/metrics': typeof WarehouseMetricsRouteRouteWithChildren
  '/warehouse/overview': typeof WarehouseOverviewRouteRouteWithChildren
  '/warehouse/source-tables': typeof WarehouseSourceTablesRouteRouteWithChildren
  '/agents/': typeof AgentsIndexRoute
  '/api-keys/': typeof ApiKeysIndexRoute
  '/content/': typeof ContentIndexRoute
  '/draft-experiments/': typeof DraftExperimentsIndexRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/figma/': typeof FigmaIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/source-templates/': typeof SourceTemplatesIndexRoute
  '/warehouse/': typeof WarehouseIndexRoute
  '/content/rules/groups': typeof ContentRulesGroupsRouteRouteWithChildren
  '/content/variables/$typeId': typeof ContentVariablesTypeIdRouteRouteWithChildren
  '/experiments/$id/variants': typeof ExperimentsIdVariantsRouteRouteWithChildren
  '/agents/figma-convert/history': typeof AgentsFigmaConvertHistoryRoute
  '/content/templates/new': typeof ContentTemplatesNewRoute
  '/content/rules/$ruleId': typeof ContentRulesRuleIdLazyRoute
  '/content/rules/new': typeof ContentRulesNewLazyRoute
  '/content/schemas/$schemaId': typeof ContentSchemasSchemaIdLazyRoute
  '/content/schemas/new': typeof ContentSchemasNewLazyRoute
  '/content/styles/$styleId': typeof ContentStylesStyleIdLazyRoute
  '/content/styles/new': typeof ContentStylesNewLazyRoute
  '/content/templates/$templateId': typeof ContentTemplatesTemplateIdLazyRoute
  '/content/variables/new': typeof ContentVariablesNewLazyRoute
  '/draft-experiments/$id/setup': typeof DraftExperimentsIdSetupLazyRoute
  '/experiments/$id/control': typeof ExperimentsIdControlLazyRoute
  '/experiments/$id/diagnostics': typeof ExperimentsIdDiagnosticsLazyRoute
  '/experiments/$id/results': typeof ExperimentsIdResultsLazyRoute
  '/experiments/$id/setup': typeof ExperimentsIdSetupLazyRoute
  '/warehouse/features/$featureId': typeof WarehouseFeaturesFeatureIdLazyRoute
  '/warehouse/features/new': typeof WarehouseFeaturesNewLazyRoute
  '/warehouse/id-types/$idTypeId': typeof WarehouseIdTypesIdTypeIdLazyRoute
  '/warehouse/id-types/new': typeof WarehouseIdTypesNewLazyRoute
  '/warehouse/metrics/$metricId': typeof WarehouseMetricsMetricIdLazyRoute
  '/warehouse/metrics/new': typeof WarehouseMetricsNewLazyRoute
  '/warehouse/source-tables/$sourceTableId': typeof WarehouseSourceTablesSourceTableIdLazyRoute
  '/warehouse/source-tables/new': typeof WarehouseSourceTablesNewLazyRoute
  '/agents/figma-convert/': typeof AgentsFigmaConvertIndexRoute
  '/content/evaluation/': typeof ContentEvaluationIndexRoute
  '/content/evaluator/': typeof ContentEvaluatorIndexRoute
  '/content/rules/': typeof ContentRulesIndexRoute
  '/content/schemas/': typeof ContentSchemasIndexRoute
  '/content/styles/': typeof ContentStylesIndexRoute
  '/content/templates/': typeof ContentTemplatesIndexRoute
  '/content/variables/': typeof ContentVariablesIndexRoute
  '/draft-experiments/$id/': typeof DraftExperimentsIdIndexRoute
  '/settings/team/': typeof SettingsTeamIndexRoute
  '/warehouse/features/': typeof WarehouseFeaturesIndexRoute
  '/warehouse/id-types/': typeof WarehouseIdTypesIndexRoute
  '/warehouse/metrics/': typeof WarehouseMetricsIndexRoute
  '/warehouse/overview/': typeof WarehouseOverviewIndexRoute
  '/warehouse/source-tables/': typeof WarehouseSourceTablesIndexRoute
  '/content/rules/groups/$groupId': typeof ContentRulesGroupsGroupIdLazyRoute
  '/content/rules/groups/new': typeof ContentRulesGroupsNewLazyRoute
  '/content/variables/$typeId/structure': typeof ContentVariablesTypeIdStructureLazyRoute
  '/content/variables/$typeId/values': typeof ContentVariablesTypeIdValuesLazyRoute
  '/experiments/$id/variants/new': typeof ExperimentsIdVariantsNewLazyRoute
  '/content/rules/groups/': typeof ContentRulesGroupsIndexRoute
  '/content/variables/$typeId/': typeof ContentVariablesTypeIdIndexRoute
  '/draft-experiments/$id/review/': typeof DraftExperimentsIdReviewIndexRoute
  '/draft-experiments/$id/generation/': typeof DraftExperimentsIdGenerationIndexLazyRoute
  '/experiments/$id/variants/': typeof ExperimentsIdVariantsIndexLazyRoute
  '/draft-experiments/$id/generation/variants/$variantId': typeof DraftExperimentsIdGenerationVariantsVariantIdRouteRouteWithChildren
  '/draft-experiments/$id/review/variants/$variantId': typeof DraftExperimentsIdReviewVariantsVariantIdRouteRouteWithChildren
  '/draft-experiments/$id/variants/$variantId/edit': typeof DraftExperimentsIdVariantsVariantIdEditRoute
  '/experiments/$id/variants/$variantId/edit': typeof ExperimentsIdVariantsVariantIdEditLazyRoute
  '/draft-experiments/$id/generation/variants/$variantId/$tab': typeof DraftExperimentsIdGenerationVariantsVariantIdTabRoute
  '/draft-experiments/$id/review/variants/$variantId/$tab': typeof DraftExperimentsIdReviewVariantsVariantIdTabRoute
  '/draft-experiments/$id/generation/variants/$variantId/': typeof DraftExperimentsIdGenerationVariantsVariantIdIndexRoute
  '/draft-experiments/$id/review/variants/$variantId/': typeof DraftExperimentsIdReviewVariantsVariantIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agents'
    | '/api-keys'
    | '/content'
    | '/draft-experiments'
    | '/experiments'
    | '/figma'
    | '/integrations'
    | '/jobs'
    | '/settings'
    | '/source-templates'
    | '/warehouse'
    | '/agents/figma-convert'
    | '/content/evaluation'
    | '/content/evaluator'
    | '/content/rules'
    | '/content/schemas'
    | '/content/styles'
    | '/content/templates'
    | '/content/variables'
    | '/draft-experiments/$id'
    | '/experiments/$id'
    | '/warehouse/features'
    | '/warehouse/id-types'
    | '/warehouse/metrics'
    | '/warehouse/overview'
    | '/warehouse/source-tables'
    | '/agents/'
    | '/api-keys/'
    | '/content/'
    | '/draft-experiments/'
    | '/experiments/'
    | '/figma/'
    | '/integrations/'
    | '/jobs/'
    | '/settings/'
    | '/source-templates/'
    | '/warehouse/'
    | '/content/rules/groups'
    | '/content/variables/$typeId'
    | '/experiments/$id/variants'
    | '/agents/figma-convert/history'
    | '/content/templates/new'
    | '/content/rules/$ruleId'
    | '/content/rules/new'
    | '/content/schemas/$schemaId'
    | '/content/schemas/new'
    | '/content/styles/$styleId'
    | '/content/styles/new'
    | '/content/templates/$templateId'
    | '/content/variables/new'
    | '/draft-experiments/$id/setup'
    | '/experiments/$id/control'
    | '/experiments/$id/diagnostics'
    | '/experiments/$id/results'
    | '/experiments/$id/setup'
    | '/warehouse/features/$featureId'
    | '/warehouse/features/new'
    | '/warehouse/id-types/$idTypeId'
    | '/warehouse/id-types/new'
    | '/warehouse/metrics/$metricId'
    | '/warehouse/metrics/new'
    | '/warehouse/source-tables/$sourceTableId'
    | '/warehouse/source-tables/new'
    | '/agents/figma-convert/'
    | '/content/evaluation/'
    | '/content/evaluator/'
    | '/content/rules/'
    | '/content/schemas/'
    | '/content/styles/'
    | '/content/templates/'
    | '/content/variables/'
    | '/draft-experiments/$id/'
    | '/settings/team'
    | '/warehouse/features/'
    | '/warehouse/id-types/'
    | '/warehouse/metrics/'
    | '/warehouse/overview/'
    | '/warehouse/source-tables/'
    | '/content/rules/groups/$groupId'
    | '/content/rules/groups/new'
    | '/content/variables/$typeId/structure'
    | '/content/variables/$typeId/values'
    | '/experiments/$id/variants/new'
    | '/content/rules/groups/'
    | '/content/variables/$typeId/'
    | '/draft-experiments/$id/review'
    | '/draft-experiments/$id/generation'
    | '/experiments/$id/variants/'
    | '/draft-experiments/$id/generation/variants/$variantId'
    | '/draft-experiments/$id/review/variants/$variantId'
    | '/draft-experiments/$id/variants/$variantId/edit'
    | '/experiments/$id/variants/$variantId/edit'
    | '/draft-experiments/$id/generation/variants/$variantId/$tab'
    | '/draft-experiments/$id/review/variants/$variantId/$tab'
    | '/draft-experiments/$id/generation/variants/$variantId/'
    | '/draft-experiments/$id/review/variants/$variantId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/experiments/$id'
    | '/agents'
    | '/api-keys'
    | '/content'
    | '/draft-experiments'
    | '/experiments'
    | '/figma'
    | '/integrations'
    | '/jobs'
    | '/settings'
    | '/source-templates'
    | '/warehouse'
    | '/agents/figma-convert/history'
    | '/content/templates/new'
    | '/content/rules/$ruleId'
    | '/content/rules/new'
    | '/content/schemas/$schemaId'
    | '/content/schemas/new'
    | '/content/styles/$styleId'
    | '/content/styles/new'
    | '/content/templates/$templateId'
    | '/content/variables/new'
    | '/draft-experiments/$id/setup'
    | '/experiments/$id/control'
    | '/experiments/$id/diagnostics'
    | '/experiments/$id/results'
    | '/experiments/$id/setup'
    | '/warehouse/features/$featureId'
    | '/warehouse/features/new'
    | '/warehouse/id-types/$idTypeId'
    | '/warehouse/id-types/new'
    | '/warehouse/metrics/$metricId'
    | '/warehouse/metrics/new'
    | '/warehouse/source-tables/$sourceTableId'
    | '/warehouse/source-tables/new'
    | '/agents/figma-convert'
    | '/content/evaluation'
    | '/content/evaluator'
    | '/content/rules'
    | '/content/schemas'
    | '/content/styles'
    | '/content/templates'
    | '/content/variables'
    | '/draft-experiments/$id'
    | '/settings/team'
    | '/warehouse/features'
    | '/warehouse/id-types'
    | '/warehouse/metrics'
    | '/warehouse/overview'
    | '/warehouse/source-tables'
    | '/content/rules/groups/$groupId'
    | '/content/rules/groups/new'
    | '/content/variables/$typeId/structure'
    | '/content/variables/$typeId/values'
    | '/experiments/$id/variants/new'
    | '/content/rules/groups'
    | '/content/variables/$typeId'
    | '/draft-experiments/$id/review'
    | '/draft-experiments/$id/generation'
    | '/experiments/$id/variants'
    | '/draft-experiments/$id/variants/$variantId/edit'
    | '/experiments/$id/variants/$variantId/edit'
    | '/draft-experiments/$id/generation/variants/$variantId/$tab'
    | '/draft-experiments/$id/review/variants/$variantId/$tab'
    | '/draft-experiments/$id/generation/variants/$variantId'
    | '/draft-experiments/$id/review/variants/$variantId'
  id:
    | '__root__'
    | '/'
    | '/agents'
    | '/api-keys'
    | '/content'
    | '/draft-experiments'
    | '/experiments'
    | '/figma'
    | '/integrations'
    | '/jobs'
    | '/settings'
    | '/source-templates'
    | '/warehouse'
    | '/agents/figma-convert'
    | '/content/evaluation'
    | '/content/evaluator'
    | '/content/rules'
    | '/content/schemas'
    | '/content/styles'
    | '/content/templates'
    | '/content/variables'
    | '/draft-experiments/$id'
    | '/experiments/$id'
    | '/warehouse/features'
    | '/warehouse/id-types'
    | '/warehouse/metrics'
    | '/warehouse/overview'
    | '/warehouse/source-tables'
    | '/agents/'
    | '/api-keys/'
    | '/content/'
    | '/draft-experiments/'
    | '/experiments/'
    | '/figma/'
    | '/integrations/'
    | '/jobs/'
    | '/settings/'
    | '/source-templates/'
    | '/warehouse/'
    | '/content/rules/groups'
    | '/content/variables/$typeId'
    | '/experiments/$id/variants'
    | '/agents/figma-convert/history'
    | '/content/templates/new'
    | '/content/rules/$ruleId'
    | '/content/rules/new'
    | '/content/schemas/$schemaId'
    | '/content/schemas/new'
    | '/content/styles/$styleId'
    | '/content/styles/new'
    | '/content/templates/$templateId'
    | '/content/variables/new'
    | '/draft-experiments/$id/setup'
    | '/experiments/$id/control'
    | '/experiments/$id/diagnostics'
    | '/experiments/$id/results'
    | '/experiments/$id/setup'
    | '/warehouse/features/$featureId'
    | '/warehouse/features/new'
    | '/warehouse/id-types/$idTypeId'
    | '/warehouse/id-types/new'
    | '/warehouse/metrics/$metricId'
    | '/warehouse/metrics/new'
    | '/warehouse/source-tables/$sourceTableId'
    | '/warehouse/source-tables/new'
    | '/agents/figma-convert/'
    | '/content/evaluation/'
    | '/content/evaluator/'
    | '/content/rules/'
    | '/content/schemas/'
    | '/content/styles/'
    | '/content/templates/'
    | '/content/variables/'
    | '/draft-experiments/$id/'
    | '/settings/team/'
    | '/warehouse/features/'
    | '/warehouse/id-types/'
    | '/warehouse/metrics/'
    | '/warehouse/overview/'
    | '/warehouse/source-tables/'
    | '/content/rules/groups/$groupId'
    | '/content/rules/groups/new'
    | '/content/variables/$typeId/structure'
    | '/content/variables/$typeId/values'
    | '/experiments/$id/variants/new'
    | '/content/rules/groups/'
    | '/content/variables/$typeId/'
    | '/draft-experiments/$id/review/'
    | '/draft-experiments/$id/generation/'
    | '/experiments/$id/variants/'
    | '/draft-experiments/$id/generation/variants/$variantId'
    | '/draft-experiments/$id/review/variants/$variantId'
    | '/draft-experiments/$id/variants/$variantId/edit'
    | '/experiments/$id/variants/$variantId/edit'
    | '/draft-experiments/$id/generation/variants/$variantId/$tab'
    | '/draft-experiments/$id/review/variants/$variantId/$tab'
    | '/draft-experiments/$id/generation/variants/$variantId/'
    | '/draft-experiments/$id/review/variants/$variantId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentsRouteRoute: typeof AgentsRouteRouteWithChildren
  ApiKeysRouteRoute: typeof ApiKeysRouteRouteWithChildren
  ContentRouteRoute: typeof ContentRouteRouteWithChildren
  DraftExperimentsRouteRoute: typeof DraftExperimentsRouteRouteWithChildren
  ExperimentsRouteRoute: typeof ExperimentsRouteRouteWithChildren
  FigmaRouteRoute: typeof FigmaRouteRouteWithChildren
  IntegrationsRouteRoute: typeof IntegrationsRouteRouteWithChildren
  JobsRouteRoute: typeof JobsRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  SourceTemplatesRouteRoute: typeof SourceTemplatesRouteRouteWithChildren
  WarehouseRouteRoute: typeof WarehouseRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/warehouse': {
      id: '/warehouse'
      path: '/warehouse'
      fullPath: '/warehouse'
      preLoaderRoute: typeof WarehouseRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/source-templates': {
      id: '/source-templates'
      path: '/source-templates'
      fullPath: '/source-templates'
      preLoaderRoute: typeof SourceTemplatesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/figma': {
      id: '/figma'
      path: '/figma'
      fullPath: '/figma'
      preLoaderRoute: typeof FigmaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments': {
      id: '/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof ExperimentsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/draft-experiments': {
      id: '/draft-experiments'
      path: '/draft-experiments'
      fullPath: '/draft-experiments'
      preLoaderRoute: typeof DraftExperimentsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content': {
      id: '/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof ContentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/warehouse/': {
      id: '/warehouse/'
      path: '/'
      fullPath: '/warehouse/'
      preLoaderRoute: typeof WarehouseIndexRouteImport
      parentRoute: typeof WarehouseRouteRoute
    }
    '/source-templates/': {
      id: '/source-templates/'
      path: '/'
      fullPath: '/source-templates/'
      preLoaderRoute: typeof SourceTemplatesIndexRouteImport
      parentRoute: typeof SourceTemplatesRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof JobsRouteRoute
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof IntegrationsRouteRoute
    }
    '/figma/': {
      id: '/figma/'
      path: '/'
      fullPath: '/figma/'
      preLoaderRoute: typeof FigmaIndexRouteImport
      parentRoute: typeof FigmaRouteRoute
    }
    '/experiments/': {
      id: '/experiments/'
      path: '/'
      fullPath: '/experiments/'
      preLoaderRoute: typeof ExperimentsIndexRouteImport
      parentRoute: typeof ExperimentsRouteRoute
    }
    '/draft-experiments/': {
      id: '/draft-experiments/'
      path: '/'
      fullPath: '/draft-experiments/'
      preLoaderRoute: typeof DraftExperimentsIndexRouteImport
      parentRoute: typeof DraftExperimentsRouteRoute
    }
    '/content/': {
      id: '/content/'
      path: '/'
      fullPath: '/content/'
      preLoaderRoute: typeof ContentIndexRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/api-keys/': {
      id: '/api-keys/'
      path: '/'
      fullPath: '/api-keys/'
      preLoaderRoute: typeof ApiKeysIndexRouteImport
      parentRoute: typeof ApiKeysRouteRoute
    }
    '/agents/': {
      id: '/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/warehouse/source-tables': {
      id: '/warehouse/source-tables'
      path: '/source-tables'
      fullPath: '/warehouse/source-tables'
      preLoaderRoute: typeof WarehouseSourceTablesRouteRouteImport
      parentRoute: typeof WarehouseRouteRoute
    }
    '/warehouse/overview': {
      id: '/warehouse/overview'
      path: '/overview'
      fullPath: '/warehouse/overview'
      preLoaderRoute: typeof WarehouseOverviewRouteRouteImport
      parentRoute: typeof WarehouseRouteRoute
    }
    '/warehouse/metrics': {
      id: '/warehouse/metrics'
      path: '/metrics'
      fullPath: '/warehouse/metrics'
      preLoaderRoute: typeof WarehouseMetricsRouteRouteImport
      parentRoute: typeof WarehouseRouteRoute
    }
    '/warehouse/id-types': {
      id: '/warehouse/id-types'
      path: '/id-types'
      fullPath: '/warehouse/id-types'
      preLoaderRoute: typeof WarehouseIdTypesRouteRouteImport
      parentRoute: typeof WarehouseRouteRoute
    }
    '/warehouse/features': {
      id: '/warehouse/features'
      path: '/features'
      fullPath: '/warehouse/features'
      preLoaderRoute: typeof WarehouseFeaturesRouteRouteImport
      parentRoute: typeof WarehouseRouteRoute
    }
    '/experiments/$id': {
      id: '/experiments/$id'
      path: '/$id'
      fullPath: '/experiments/$id'
      preLoaderRoute: typeof ExperimentsIdRouteRouteImport
      parentRoute: typeof ExperimentsRouteRoute
    }
    '/draft-experiments/$id': {
      id: '/draft-experiments/$id'
      path: '/$id'
      fullPath: '/draft-experiments/$id'
      preLoaderRoute: typeof DraftExperimentsIdRouteRouteImport
      parentRoute: typeof DraftExperimentsRouteRoute
    }
    '/content/variables': {
      id: '/content/variables'
      path: '/variables'
      fullPath: '/content/variables'
      preLoaderRoute: typeof ContentVariablesRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/templates': {
      id: '/content/templates'
      path: '/templates'
      fullPath: '/content/templates'
      preLoaderRoute: typeof ContentTemplatesRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/styles': {
      id: '/content/styles'
      path: '/styles'
      fullPath: '/content/styles'
      preLoaderRoute: typeof ContentStylesRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/schemas': {
      id: '/content/schemas'
      path: '/schemas'
      fullPath: '/content/schemas'
      preLoaderRoute: typeof ContentSchemasRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/rules': {
      id: '/content/rules'
      path: '/rules'
      fullPath: '/content/rules'
      preLoaderRoute: typeof ContentRulesRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/evaluator': {
      id: '/content/evaluator'
      path: '/evaluator'
      fullPath: '/content/evaluator'
      preLoaderRoute: typeof ContentEvaluatorRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/evaluation': {
      id: '/content/evaluation'
      path: '/evaluation'
      fullPath: '/content/evaluation'
      preLoaderRoute: typeof ContentEvaluationRouteRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/agents/figma-convert': {
      id: '/agents/figma-convert'
      path: '/figma-convert'
      fullPath: '/agents/figma-convert'
      preLoaderRoute: typeof AgentsFigmaConvertRouteRouteImport
      parentRoute: typeof AgentsRouteRoute
    }
    '/warehouse/source-tables/': {
      id: '/warehouse/source-tables/'
      path: '/'
      fullPath: '/warehouse/source-tables/'
      preLoaderRoute: typeof WarehouseSourceTablesIndexRouteImport
      parentRoute: typeof WarehouseSourceTablesRouteRoute
    }
    '/warehouse/overview/': {
      id: '/warehouse/overview/'
      path: '/'
      fullPath: '/warehouse/overview/'
      preLoaderRoute: typeof WarehouseOverviewIndexRouteImport
      parentRoute: typeof WarehouseOverviewRouteRoute
    }
    '/warehouse/metrics/': {
      id: '/warehouse/metrics/'
      path: '/'
      fullPath: '/warehouse/metrics/'
      preLoaderRoute: typeof WarehouseMetricsIndexRouteImport
      parentRoute: typeof WarehouseMetricsRouteRoute
    }
    '/warehouse/id-types/': {
      id: '/warehouse/id-types/'
      path: '/'
      fullPath: '/warehouse/id-types/'
      preLoaderRoute: typeof WarehouseIdTypesIndexRouteImport
      parentRoute: typeof WarehouseIdTypesRouteRoute
    }
    '/warehouse/features/': {
      id: '/warehouse/features/'
      path: '/'
      fullPath: '/warehouse/features/'
      preLoaderRoute: typeof WarehouseFeaturesIndexRouteImport
      parentRoute: typeof WarehouseFeaturesRouteRoute
    }
    '/settings/team/': {
      id: '/settings/team/'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/draft-experiments/$id/': {
      id: '/draft-experiments/$id/'
      path: '/'
      fullPath: '/draft-experiments/$id/'
      preLoaderRoute: typeof DraftExperimentsIdIndexRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/content/variables/': {
      id: '/content/variables/'
      path: '/'
      fullPath: '/content/variables/'
      preLoaderRoute: typeof ContentVariablesIndexRouteImport
      parentRoute: typeof ContentVariablesRouteRoute
    }
    '/content/templates/': {
      id: '/content/templates/'
      path: '/'
      fullPath: '/content/templates/'
      preLoaderRoute: typeof ContentTemplatesIndexRouteImport
      parentRoute: typeof ContentTemplatesRouteRoute
    }
    '/content/styles/': {
      id: '/content/styles/'
      path: '/'
      fullPath: '/content/styles/'
      preLoaderRoute: typeof ContentStylesIndexRouteImport
      parentRoute: typeof ContentStylesRouteRoute
    }
    '/content/schemas/': {
      id: '/content/schemas/'
      path: '/'
      fullPath: '/content/schemas/'
      preLoaderRoute: typeof ContentSchemasIndexRouteImport
      parentRoute: typeof ContentSchemasRouteRoute
    }
    '/content/rules/': {
      id: '/content/rules/'
      path: '/'
      fullPath: '/content/rules/'
      preLoaderRoute: typeof ContentRulesIndexRouteImport
      parentRoute: typeof ContentRulesRouteRoute
    }
    '/content/evaluator/': {
      id: '/content/evaluator/'
      path: '/'
      fullPath: '/content/evaluator/'
      preLoaderRoute: typeof ContentEvaluatorIndexRouteImport
      parentRoute: typeof ContentEvaluatorRouteRoute
    }
    '/content/evaluation/': {
      id: '/content/evaluation/'
      path: '/'
      fullPath: '/content/evaluation/'
      preLoaderRoute: typeof ContentEvaluationIndexRouteImport
      parentRoute: typeof ContentEvaluationRouteRoute
    }
    '/agents/figma-convert/': {
      id: '/agents/figma-convert/'
      path: '/'
      fullPath: '/agents/figma-convert/'
      preLoaderRoute: typeof AgentsFigmaConvertIndexRouteImport
      parentRoute: typeof AgentsFigmaConvertRouteRoute
    }
    '/warehouse/source-tables/new': {
      id: '/warehouse/source-tables/new'
      path: '/new'
      fullPath: '/warehouse/source-tables/new'
      preLoaderRoute: typeof WarehouseSourceTablesNewLazyRouteImport
      parentRoute: typeof WarehouseSourceTablesRouteRoute
    }
    '/warehouse/source-tables/$sourceTableId': {
      id: '/warehouse/source-tables/$sourceTableId'
      path: '/$sourceTableId'
      fullPath: '/warehouse/source-tables/$sourceTableId'
      preLoaderRoute: typeof WarehouseSourceTablesSourceTableIdLazyRouteImport
      parentRoute: typeof WarehouseSourceTablesRouteRoute
    }
    '/warehouse/metrics/new': {
      id: '/warehouse/metrics/new'
      path: '/new'
      fullPath: '/warehouse/metrics/new'
      preLoaderRoute: typeof WarehouseMetricsNewLazyRouteImport
      parentRoute: typeof WarehouseMetricsRouteRoute
    }
    '/warehouse/metrics/$metricId': {
      id: '/warehouse/metrics/$metricId'
      path: '/$metricId'
      fullPath: '/warehouse/metrics/$metricId'
      preLoaderRoute: typeof WarehouseMetricsMetricIdLazyRouteImport
      parentRoute: typeof WarehouseMetricsRouteRoute
    }
    '/warehouse/id-types/new': {
      id: '/warehouse/id-types/new'
      path: '/new'
      fullPath: '/warehouse/id-types/new'
      preLoaderRoute: typeof WarehouseIdTypesNewLazyRouteImport
      parentRoute: typeof WarehouseIdTypesRouteRoute
    }
    '/warehouse/id-types/$idTypeId': {
      id: '/warehouse/id-types/$idTypeId'
      path: '/$idTypeId'
      fullPath: '/warehouse/id-types/$idTypeId'
      preLoaderRoute: typeof WarehouseIdTypesIdTypeIdLazyRouteImport
      parentRoute: typeof WarehouseIdTypesRouteRoute
    }
    '/warehouse/features/new': {
      id: '/warehouse/features/new'
      path: '/new'
      fullPath: '/warehouse/features/new'
      preLoaderRoute: typeof WarehouseFeaturesNewLazyRouteImport
      parentRoute: typeof WarehouseFeaturesRouteRoute
    }
    '/warehouse/features/$featureId': {
      id: '/warehouse/features/$featureId'
      path: '/$featureId'
      fullPath: '/warehouse/features/$featureId'
      preLoaderRoute: typeof WarehouseFeaturesFeatureIdLazyRouteImport
      parentRoute: typeof WarehouseFeaturesRouteRoute
    }
    '/experiments/$id/setup': {
      id: '/experiments/$id/setup'
      path: '/setup'
      fullPath: '/experiments/$id/setup'
      preLoaderRoute: typeof ExperimentsIdSetupLazyRouteImport
      parentRoute: typeof ExperimentsIdRouteRoute
    }
    '/experiments/$id/results': {
      id: '/experiments/$id/results'
      path: '/results'
      fullPath: '/experiments/$id/results'
      preLoaderRoute: typeof ExperimentsIdResultsLazyRouteImport
      parentRoute: typeof ExperimentsIdRouteRoute
    }
    '/experiments/$id/diagnostics': {
      id: '/experiments/$id/diagnostics'
      path: '/diagnostics'
      fullPath: '/experiments/$id/diagnostics'
      preLoaderRoute: typeof ExperimentsIdDiagnosticsLazyRouteImport
      parentRoute: typeof ExperimentsIdRouteRoute
    }
    '/experiments/$id/control': {
      id: '/experiments/$id/control'
      path: '/control'
      fullPath: '/experiments/$id/control'
      preLoaderRoute: typeof ExperimentsIdControlLazyRouteImport
      parentRoute: typeof ExperimentsIdRouteRoute
    }
    '/draft-experiments/$id/setup': {
      id: '/draft-experiments/$id/setup'
      path: '/setup'
      fullPath: '/draft-experiments/$id/setup'
      preLoaderRoute: typeof DraftExperimentsIdSetupLazyRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/content/variables/new': {
      id: '/content/variables/new'
      path: '/new'
      fullPath: '/content/variables/new'
      preLoaderRoute: typeof ContentVariablesNewLazyRouteImport
      parentRoute: typeof ContentVariablesRouteRoute
    }
    '/content/templates/$templateId': {
      id: '/content/templates/$templateId'
      path: '/$templateId'
      fullPath: '/content/templates/$templateId'
      preLoaderRoute: typeof ContentTemplatesTemplateIdLazyRouteImport
      parentRoute: typeof ContentTemplatesRouteRoute
    }
    '/content/styles/new': {
      id: '/content/styles/new'
      path: '/new'
      fullPath: '/content/styles/new'
      preLoaderRoute: typeof ContentStylesNewLazyRouteImport
      parentRoute: typeof ContentStylesRouteRoute
    }
    '/content/styles/$styleId': {
      id: '/content/styles/$styleId'
      path: '/$styleId'
      fullPath: '/content/styles/$styleId'
      preLoaderRoute: typeof ContentStylesStyleIdLazyRouteImport
      parentRoute: typeof ContentStylesRouteRoute
    }
    '/content/schemas/new': {
      id: '/content/schemas/new'
      path: '/new'
      fullPath: '/content/schemas/new'
      preLoaderRoute: typeof ContentSchemasNewLazyRouteImport
      parentRoute: typeof ContentSchemasRouteRoute
    }
    '/content/schemas/$schemaId': {
      id: '/content/schemas/$schemaId'
      path: '/$schemaId'
      fullPath: '/content/schemas/$schemaId'
      preLoaderRoute: typeof ContentSchemasSchemaIdLazyRouteImport
      parentRoute: typeof ContentSchemasRouteRoute
    }
    '/content/rules/new': {
      id: '/content/rules/new'
      path: '/new'
      fullPath: '/content/rules/new'
      preLoaderRoute: typeof ContentRulesNewLazyRouteImport
      parentRoute: typeof ContentRulesRouteRoute
    }
    '/content/rules/$ruleId': {
      id: '/content/rules/$ruleId'
      path: '/$ruleId'
      fullPath: '/content/rules/$ruleId'
      preLoaderRoute: typeof ContentRulesRuleIdLazyRouteImport
      parentRoute: typeof ContentRulesRouteRoute
    }
    '/content/templates/new': {
      id: '/content/templates/new'
      path: '/new'
      fullPath: '/content/templates/new'
      preLoaderRoute: typeof ContentTemplatesNewRouteImport
      parentRoute: typeof ContentTemplatesRouteRoute
    }
    '/agents/figma-convert/history': {
      id: '/agents/figma-convert/history'
      path: '/history'
      fullPath: '/agents/figma-convert/history'
      preLoaderRoute: typeof AgentsFigmaConvertHistoryRouteImport
      parentRoute: typeof AgentsFigmaConvertRouteRoute
    }
    '/experiments/$id/variants': {
      id: '/experiments/$id/variants'
      path: '/variants'
      fullPath: '/experiments/$id/variants'
      preLoaderRoute: typeof ExperimentsIdVariantsRouteRouteImport
      parentRoute: typeof ExperimentsIdRouteRoute
    }
    '/content/variables/$typeId': {
      id: '/content/variables/$typeId'
      path: '/$typeId'
      fullPath: '/content/variables/$typeId'
      preLoaderRoute: typeof ContentVariablesTypeIdRouteRouteImport
      parentRoute: typeof ContentVariablesRouteRoute
    }
    '/content/rules/groups': {
      id: '/content/rules/groups'
      path: '/groups'
      fullPath: '/content/rules/groups'
      preLoaderRoute: typeof ContentRulesGroupsRouteRouteImport
      parentRoute: typeof ContentRulesRouteRoute
    }
    '/experiments/$id/variants/': {
      id: '/experiments/$id/variants/'
      path: '/'
      fullPath: '/experiments/$id/variants/'
      preLoaderRoute: typeof ExperimentsIdVariantsIndexLazyRouteImport
      parentRoute: typeof ExperimentsIdVariantsRouteRoute
    }
    '/draft-experiments/$id/generation/': {
      id: '/draft-experiments/$id/generation/'
      path: '/generation'
      fullPath: '/draft-experiments/$id/generation'
      preLoaderRoute: typeof DraftExperimentsIdGenerationIndexLazyRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/draft-experiments/$id/review/': {
      id: '/draft-experiments/$id/review/'
      path: '/review'
      fullPath: '/draft-experiments/$id/review'
      preLoaderRoute: typeof DraftExperimentsIdReviewIndexRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/content/variables/$typeId/': {
      id: '/content/variables/$typeId/'
      path: '/'
      fullPath: '/content/variables/$typeId/'
      preLoaderRoute: typeof ContentVariablesTypeIdIndexRouteImport
      parentRoute: typeof ContentVariablesTypeIdRouteRoute
    }
    '/content/rules/groups/': {
      id: '/content/rules/groups/'
      path: '/'
      fullPath: '/content/rules/groups/'
      preLoaderRoute: typeof ContentRulesGroupsIndexRouteImport
      parentRoute: typeof ContentRulesGroupsRouteRoute
    }
    '/experiments/$id/variants/new': {
      id: '/experiments/$id/variants/new'
      path: '/new'
      fullPath: '/experiments/$id/variants/new'
      preLoaderRoute: typeof ExperimentsIdVariantsNewLazyRouteImport
      parentRoute: typeof ExperimentsIdVariantsRouteRoute
    }
    '/content/variables/$typeId/values': {
      id: '/content/variables/$typeId/values'
      path: '/values'
      fullPath: '/content/variables/$typeId/values'
      preLoaderRoute: typeof ContentVariablesTypeIdValuesLazyRouteImport
      parentRoute: typeof ContentVariablesTypeIdRouteRoute
    }
    '/content/variables/$typeId/structure': {
      id: '/content/variables/$typeId/structure'
      path: '/structure'
      fullPath: '/content/variables/$typeId/structure'
      preLoaderRoute: typeof ContentVariablesTypeIdStructureLazyRouteImport
      parentRoute: typeof ContentVariablesTypeIdRouteRoute
    }
    '/content/rules/groups/new': {
      id: '/content/rules/groups/new'
      path: '/new'
      fullPath: '/content/rules/groups/new'
      preLoaderRoute: typeof ContentRulesGroupsNewLazyRouteImport
      parentRoute: typeof ContentRulesGroupsRouteRoute
    }
    '/content/rules/groups/$groupId': {
      id: '/content/rules/groups/$groupId'
      path: '/$groupId'
      fullPath: '/content/rules/groups/$groupId'
      preLoaderRoute: typeof ContentRulesGroupsGroupIdLazyRouteImport
      parentRoute: typeof ContentRulesGroupsRouteRoute
    }
    '/experiments/$id/variants/$variantId/edit': {
      id: '/experiments/$id/variants/$variantId/edit'
      path: '/$variantId/edit'
      fullPath: '/experiments/$id/variants/$variantId/edit'
      preLoaderRoute: typeof ExperimentsIdVariantsVariantIdEditLazyRouteImport
      parentRoute: typeof ExperimentsIdVariantsRouteRoute
    }
    '/draft-experiments/$id/variants/$variantId/edit': {
      id: '/draft-experiments/$id/variants/$variantId/edit'
      path: '/variants/$variantId/edit'
      fullPath: '/draft-experiments/$id/variants/$variantId/edit'
      preLoaderRoute: typeof DraftExperimentsIdVariantsVariantIdEditRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/draft-experiments/$id/review/variants/$variantId': {
      id: '/draft-experiments/$id/review/variants/$variantId'
      path: '/review/variants/$variantId'
      fullPath: '/draft-experiments/$id/review/variants/$variantId'
      preLoaderRoute: typeof DraftExperimentsIdReviewVariantsVariantIdRouteRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/draft-experiments/$id/generation/variants/$variantId': {
      id: '/draft-experiments/$id/generation/variants/$variantId'
      path: '/generation/variants/$variantId'
      fullPath: '/draft-experiments/$id/generation/variants/$variantId'
      preLoaderRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdRouteRouteImport
      parentRoute: typeof DraftExperimentsIdRouteRoute
    }
    '/draft-experiments/$id/review/variants/$variantId/': {
      id: '/draft-experiments/$id/review/variants/$variantId/'
      path: '/'
      fullPath: '/draft-experiments/$id/review/variants/$variantId/'
      preLoaderRoute: typeof DraftExperimentsIdReviewVariantsVariantIdIndexRouteImport
      parentRoute: typeof DraftExperimentsIdReviewVariantsVariantIdRouteRoute
    }
    '/draft-experiments/$id/generation/variants/$variantId/': {
      id: '/draft-experiments/$id/generation/variants/$variantId/'
      path: '/'
      fullPath: '/draft-experiments/$id/generation/variants/$variantId/'
      preLoaderRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdIndexRouteImport
      parentRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdRouteRoute
    }
    '/draft-experiments/$id/review/variants/$variantId/$tab': {
      id: '/draft-experiments/$id/review/variants/$variantId/$tab'
      path: '/$tab'
      fullPath: '/draft-experiments/$id/review/variants/$variantId/$tab'
      preLoaderRoute: typeof DraftExperimentsIdReviewVariantsVariantIdTabRouteImport
      parentRoute: typeof DraftExperimentsIdReviewVariantsVariantIdRouteRoute
    }
    '/draft-experiments/$id/generation/variants/$variantId/$tab': {
      id: '/draft-experiments/$id/generation/variants/$variantId/$tab'
      path: '/$tab'
      fullPath: '/draft-experiments/$id/generation/variants/$variantId/$tab'
      preLoaderRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdTabRouteImport
      parentRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdRouteRoute
    }
  }
}

interface AgentsFigmaConvertRouteRouteChildren {
  AgentsFigmaConvertHistoryRoute: typeof AgentsFigmaConvertHistoryRoute
  AgentsFigmaConvertIndexRoute: typeof AgentsFigmaConvertIndexRoute
}

const AgentsFigmaConvertRouteRouteChildren: AgentsFigmaConvertRouteRouteChildren =
  {
    AgentsFigmaConvertHistoryRoute: AgentsFigmaConvertHistoryRoute,
    AgentsFigmaConvertIndexRoute: AgentsFigmaConvertIndexRoute,
  }

const AgentsFigmaConvertRouteRouteWithChildren =
  AgentsFigmaConvertRouteRoute._addFileChildren(
    AgentsFigmaConvertRouteRouteChildren,
  )

interface AgentsRouteRouteChildren {
  AgentsFigmaConvertRouteRoute: typeof AgentsFigmaConvertRouteRouteWithChildren
  AgentsIndexRoute: typeof AgentsIndexRoute
}

const AgentsRouteRouteChildren: AgentsRouteRouteChildren = {
  AgentsFigmaConvertRouteRoute: AgentsFigmaConvertRouteRouteWithChildren,
  AgentsIndexRoute: AgentsIndexRoute,
}

const AgentsRouteRouteWithChildren = AgentsRouteRoute._addFileChildren(
  AgentsRouteRouteChildren,
)

interface ApiKeysRouteRouteChildren {
  ApiKeysIndexRoute: typeof ApiKeysIndexRoute
}

const ApiKeysRouteRouteChildren: ApiKeysRouteRouteChildren = {
  ApiKeysIndexRoute: ApiKeysIndexRoute,
}

const ApiKeysRouteRouteWithChildren = ApiKeysRouteRoute._addFileChildren(
  ApiKeysRouteRouteChildren,
)

interface ContentEvaluationRouteRouteChildren {
  ContentEvaluationIndexRoute: typeof ContentEvaluationIndexRoute
}

const ContentEvaluationRouteRouteChildren: ContentEvaluationRouteRouteChildren =
  {
    ContentEvaluationIndexRoute: ContentEvaluationIndexRoute,
  }

const ContentEvaluationRouteRouteWithChildren =
  ContentEvaluationRouteRoute._addFileChildren(
    ContentEvaluationRouteRouteChildren,
  )

interface ContentEvaluatorRouteRouteChildren {
  ContentEvaluatorIndexRoute: typeof ContentEvaluatorIndexRoute
}

const ContentEvaluatorRouteRouteChildren: ContentEvaluatorRouteRouteChildren = {
  ContentEvaluatorIndexRoute: ContentEvaluatorIndexRoute,
}

const ContentEvaluatorRouteRouteWithChildren =
  ContentEvaluatorRouteRoute._addFileChildren(
    ContentEvaluatorRouteRouteChildren,
  )

interface ContentRulesGroupsRouteRouteChildren {
  ContentRulesGroupsGroupIdLazyRoute: typeof ContentRulesGroupsGroupIdLazyRoute
  ContentRulesGroupsNewLazyRoute: typeof ContentRulesGroupsNewLazyRoute
  ContentRulesGroupsIndexRoute: typeof ContentRulesGroupsIndexRoute
}

const ContentRulesGroupsRouteRouteChildren: ContentRulesGroupsRouteRouteChildren =
  {
    ContentRulesGroupsGroupIdLazyRoute: ContentRulesGroupsGroupIdLazyRoute,
    ContentRulesGroupsNewLazyRoute: ContentRulesGroupsNewLazyRoute,
    ContentRulesGroupsIndexRoute: ContentRulesGroupsIndexRoute,
  }

const ContentRulesGroupsRouteRouteWithChildren =
  ContentRulesGroupsRouteRoute._addFileChildren(
    ContentRulesGroupsRouteRouteChildren,
  )

interface ContentRulesRouteRouteChildren {
  ContentRulesGroupsRouteRoute: typeof ContentRulesGroupsRouteRouteWithChildren
  ContentRulesRuleIdLazyRoute: typeof ContentRulesRuleIdLazyRoute
  ContentRulesNewLazyRoute: typeof ContentRulesNewLazyRoute
  ContentRulesIndexRoute: typeof ContentRulesIndexRoute
}

const ContentRulesRouteRouteChildren: ContentRulesRouteRouteChildren = {
  ContentRulesGroupsRouteRoute: ContentRulesGroupsRouteRouteWithChildren,
  ContentRulesRuleIdLazyRoute: ContentRulesRuleIdLazyRoute,
  ContentRulesNewLazyRoute: ContentRulesNewLazyRoute,
  ContentRulesIndexRoute: ContentRulesIndexRoute,
}

const ContentRulesRouteRouteWithChildren =
  ContentRulesRouteRoute._addFileChildren(ContentRulesRouteRouteChildren)

interface ContentSchemasRouteRouteChildren {
  ContentSchemasSchemaIdLazyRoute: typeof ContentSchemasSchemaIdLazyRoute
  ContentSchemasNewLazyRoute: typeof ContentSchemasNewLazyRoute
  ContentSchemasIndexRoute: typeof ContentSchemasIndexRoute
}

const ContentSchemasRouteRouteChildren: ContentSchemasRouteRouteChildren = {
  ContentSchemasSchemaIdLazyRoute: ContentSchemasSchemaIdLazyRoute,
  ContentSchemasNewLazyRoute: ContentSchemasNewLazyRoute,
  ContentSchemasIndexRoute: ContentSchemasIndexRoute,
}

const ContentSchemasRouteRouteWithChildren =
  ContentSchemasRouteRoute._addFileChildren(ContentSchemasRouteRouteChildren)

interface ContentStylesRouteRouteChildren {
  ContentStylesStyleIdLazyRoute: typeof ContentStylesStyleIdLazyRoute
  ContentStylesNewLazyRoute: typeof ContentStylesNewLazyRoute
  ContentStylesIndexRoute: typeof ContentStylesIndexRoute
}

const ContentStylesRouteRouteChildren: ContentStylesRouteRouteChildren = {
  ContentStylesStyleIdLazyRoute: ContentStylesStyleIdLazyRoute,
  ContentStylesNewLazyRoute: ContentStylesNewLazyRoute,
  ContentStylesIndexRoute: ContentStylesIndexRoute,
}

const ContentStylesRouteRouteWithChildren =
  ContentStylesRouteRoute._addFileChildren(ContentStylesRouteRouteChildren)

interface ContentTemplatesRouteRouteChildren {
  ContentTemplatesNewRoute: typeof ContentTemplatesNewRoute
  ContentTemplatesTemplateIdLazyRoute: typeof ContentTemplatesTemplateIdLazyRoute
  ContentTemplatesIndexRoute: typeof ContentTemplatesIndexRoute
}

const ContentTemplatesRouteRouteChildren: ContentTemplatesRouteRouteChildren = {
  ContentTemplatesNewRoute: ContentTemplatesNewRoute,
  ContentTemplatesTemplateIdLazyRoute: ContentTemplatesTemplateIdLazyRoute,
  ContentTemplatesIndexRoute: ContentTemplatesIndexRoute,
}

const ContentTemplatesRouteRouteWithChildren =
  ContentTemplatesRouteRoute._addFileChildren(
    ContentTemplatesRouteRouteChildren,
  )

interface ContentVariablesTypeIdRouteRouteChildren {
  ContentVariablesTypeIdStructureLazyRoute: typeof ContentVariablesTypeIdStructureLazyRoute
  ContentVariablesTypeIdValuesLazyRoute: typeof ContentVariablesTypeIdValuesLazyRoute
  ContentVariablesTypeIdIndexRoute: typeof ContentVariablesTypeIdIndexRoute
}

const ContentVariablesTypeIdRouteRouteChildren: ContentVariablesTypeIdRouteRouteChildren =
  {
    ContentVariablesTypeIdStructureLazyRoute:
      ContentVariablesTypeIdStructureLazyRoute,
    ContentVariablesTypeIdValuesLazyRoute:
      ContentVariablesTypeIdValuesLazyRoute,
    ContentVariablesTypeIdIndexRoute: ContentVariablesTypeIdIndexRoute,
  }

const ContentVariablesTypeIdRouteRouteWithChildren =
  ContentVariablesTypeIdRouteRoute._addFileChildren(
    ContentVariablesTypeIdRouteRouteChildren,
  )

interface ContentVariablesRouteRouteChildren {
  ContentVariablesTypeIdRouteRoute: typeof ContentVariablesTypeIdRouteRouteWithChildren
  ContentVariablesNewLazyRoute: typeof ContentVariablesNewLazyRoute
  ContentVariablesIndexRoute: typeof ContentVariablesIndexRoute
}

const ContentVariablesRouteRouteChildren: ContentVariablesRouteRouteChildren = {
  ContentVariablesTypeIdRouteRoute:
    ContentVariablesTypeIdRouteRouteWithChildren,
  ContentVariablesNewLazyRoute: ContentVariablesNewLazyRoute,
  ContentVariablesIndexRoute: ContentVariablesIndexRoute,
}

const ContentVariablesRouteRouteWithChildren =
  ContentVariablesRouteRoute._addFileChildren(
    ContentVariablesRouteRouteChildren,
  )

interface ContentRouteRouteChildren {
  ContentEvaluationRouteRoute: typeof ContentEvaluationRouteRouteWithChildren
  ContentEvaluatorRouteRoute: typeof ContentEvaluatorRouteRouteWithChildren
  ContentRulesRouteRoute: typeof ContentRulesRouteRouteWithChildren
  ContentSchemasRouteRoute: typeof ContentSchemasRouteRouteWithChildren
  ContentStylesRouteRoute: typeof ContentStylesRouteRouteWithChildren
  ContentTemplatesRouteRoute: typeof ContentTemplatesRouteRouteWithChildren
  ContentVariablesRouteRoute: typeof ContentVariablesRouteRouteWithChildren
  ContentIndexRoute: typeof ContentIndexRoute
}

const ContentRouteRouteChildren: ContentRouteRouteChildren = {
  ContentEvaluationRouteRoute: ContentEvaluationRouteRouteWithChildren,
  ContentEvaluatorRouteRoute: ContentEvaluatorRouteRouteWithChildren,
  ContentRulesRouteRoute: ContentRulesRouteRouteWithChildren,
  ContentSchemasRouteRoute: ContentSchemasRouteRouteWithChildren,
  ContentStylesRouteRoute: ContentStylesRouteRouteWithChildren,
  ContentTemplatesRouteRoute: ContentTemplatesRouteRouteWithChildren,
  ContentVariablesRouteRoute: ContentVariablesRouteRouteWithChildren,
  ContentIndexRoute: ContentIndexRoute,
}

const ContentRouteRouteWithChildren = ContentRouteRoute._addFileChildren(
  ContentRouteRouteChildren,
)

interface DraftExperimentsIdGenerationVariantsVariantIdRouteRouteChildren {
  DraftExperimentsIdGenerationVariantsVariantIdTabRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdTabRoute
  DraftExperimentsIdGenerationVariantsVariantIdIndexRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdIndexRoute
}

const DraftExperimentsIdGenerationVariantsVariantIdRouteRouteChildren: DraftExperimentsIdGenerationVariantsVariantIdRouteRouteChildren =
  {
    DraftExperimentsIdGenerationVariantsVariantIdTabRoute:
      DraftExperimentsIdGenerationVariantsVariantIdTabRoute,
    DraftExperimentsIdGenerationVariantsVariantIdIndexRoute:
      DraftExperimentsIdGenerationVariantsVariantIdIndexRoute,
  }

const DraftExperimentsIdGenerationVariantsVariantIdRouteRouteWithChildren =
  DraftExperimentsIdGenerationVariantsVariantIdRouteRoute._addFileChildren(
    DraftExperimentsIdGenerationVariantsVariantIdRouteRouteChildren,
  )

interface DraftExperimentsIdReviewVariantsVariantIdRouteRouteChildren {
  DraftExperimentsIdReviewVariantsVariantIdTabRoute: typeof DraftExperimentsIdReviewVariantsVariantIdTabRoute
  DraftExperimentsIdReviewVariantsVariantIdIndexRoute: typeof DraftExperimentsIdReviewVariantsVariantIdIndexRoute
}

const DraftExperimentsIdReviewVariantsVariantIdRouteRouteChildren: DraftExperimentsIdReviewVariantsVariantIdRouteRouteChildren =
  {
    DraftExperimentsIdReviewVariantsVariantIdTabRoute:
      DraftExperimentsIdReviewVariantsVariantIdTabRoute,
    DraftExperimentsIdReviewVariantsVariantIdIndexRoute:
      DraftExperimentsIdReviewVariantsVariantIdIndexRoute,
  }

const DraftExperimentsIdReviewVariantsVariantIdRouteRouteWithChildren =
  DraftExperimentsIdReviewVariantsVariantIdRouteRoute._addFileChildren(
    DraftExperimentsIdReviewVariantsVariantIdRouteRouteChildren,
  )

interface DraftExperimentsIdRouteRouteChildren {
  DraftExperimentsIdSetupLazyRoute: typeof DraftExperimentsIdSetupLazyRoute
  DraftExperimentsIdIndexRoute: typeof DraftExperimentsIdIndexRoute
  DraftExperimentsIdReviewIndexRoute: typeof DraftExperimentsIdReviewIndexRoute
  DraftExperimentsIdGenerationIndexLazyRoute: typeof DraftExperimentsIdGenerationIndexLazyRoute
  DraftExperimentsIdGenerationVariantsVariantIdRouteRoute: typeof DraftExperimentsIdGenerationVariantsVariantIdRouteRouteWithChildren
  DraftExperimentsIdReviewVariantsVariantIdRouteRoute: typeof DraftExperimentsIdReviewVariantsVariantIdRouteRouteWithChildren
  DraftExperimentsIdVariantsVariantIdEditRoute: typeof DraftExperimentsIdVariantsVariantIdEditRoute
}

const DraftExperimentsIdRouteRouteChildren: DraftExperimentsIdRouteRouteChildren =
  {
    DraftExperimentsIdSetupLazyRoute: DraftExperimentsIdSetupLazyRoute,
    DraftExperimentsIdIndexRoute: DraftExperimentsIdIndexRoute,
    DraftExperimentsIdReviewIndexRoute: DraftExperimentsIdReviewIndexRoute,
    DraftExperimentsIdGenerationIndexLazyRoute:
      DraftExperimentsIdGenerationIndexLazyRoute,
    DraftExperimentsIdGenerationVariantsVariantIdRouteRoute:
      DraftExperimentsIdGenerationVariantsVariantIdRouteRouteWithChildren,
    DraftExperimentsIdReviewVariantsVariantIdRouteRoute:
      DraftExperimentsIdReviewVariantsVariantIdRouteRouteWithChildren,
    DraftExperimentsIdVariantsVariantIdEditRoute:
      DraftExperimentsIdVariantsVariantIdEditRoute,
  }

const DraftExperimentsIdRouteRouteWithChildren =
  DraftExperimentsIdRouteRoute._addFileChildren(
    DraftExperimentsIdRouteRouteChildren,
  )

interface DraftExperimentsRouteRouteChildren {
  DraftExperimentsIdRouteRoute: typeof DraftExperimentsIdRouteRouteWithChildren
  DraftExperimentsIndexRoute: typeof DraftExperimentsIndexRoute
}

const DraftExperimentsRouteRouteChildren: DraftExperimentsRouteRouteChildren = {
  DraftExperimentsIdRouteRoute: DraftExperimentsIdRouteRouteWithChildren,
  DraftExperimentsIndexRoute: DraftExperimentsIndexRoute,
}

const DraftExperimentsRouteRouteWithChildren =
  DraftExperimentsRouteRoute._addFileChildren(
    DraftExperimentsRouteRouteChildren,
  )

interface ExperimentsIdVariantsRouteRouteChildren {
  ExperimentsIdVariantsNewLazyRoute: typeof ExperimentsIdVariantsNewLazyRoute
  ExperimentsIdVariantsIndexLazyRoute: typeof ExperimentsIdVariantsIndexLazyRoute
  ExperimentsIdVariantsVariantIdEditLazyRoute: typeof ExperimentsIdVariantsVariantIdEditLazyRoute
}

const ExperimentsIdVariantsRouteRouteChildren: ExperimentsIdVariantsRouteRouteChildren =
  {
    ExperimentsIdVariantsNewLazyRoute: ExperimentsIdVariantsNewLazyRoute,
    ExperimentsIdVariantsIndexLazyRoute: ExperimentsIdVariantsIndexLazyRoute,
    ExperimentsIdVariantsVariantIdEditLazyRoute:
      ExperimentsIdVariantsVariantIdEditLazyRoute,
  }

const ExperimentsIdVariantsRouteRouteWithChildren =
  ExperimentsIdVariantsRouteRoute._addFileChildren(
    ExperimentsIdVariantsRouteRouteChildren,
  )

interface ExperimentsIdRouteRouteChildren {
  ExperimentsIdVariantsRouteRoute: typeof ExperimentsIdVariantsRouteRouteWithChildren
  ExperimentsIdControlLazyRoute: typeof ExperimentsIdControlLazyRoute
  ExperimentsIdDiagnosticsLazyRoute: typeof ExperimentsIdDiagnosticsLazyRoute
  ExperimentsIdResultsLazyRoute: typeof ExperimentsIdResultsLazyRoute
  ExperimentsIdSetupLazyRoute: typeof ExperimentsIdSetupLazyRoute
}

const ExperimentsIdRouteRouteChildren: ExperimentsIdRouteRouteChildren = {
  ExperimentsIdVariantsRouteRoute: ExperimentsIdVariantsRouteRouteWithChildren,
  ExperimentsIdControlLazyRoute: ExperimentsIdControlLazyRoute,
  ExperimentsIdDiagnosticsLazyRoute: ExperimentsIdDiagnosticsLazyRoute,
  ExperimentsIdResultsLazyRoute: ExperimentsIdResultsLazyRoute,
  ExperimentsIdSetupLazyRoute: ExperimentsIdSetupLazyRoute,
}

const ExperimentsIdRouteRouteWithChildren =
  ExperimentsIdRouteRoute._addFileChildren(ExperimentsIdRouteRouteChildren)

interface ExperimentsRouteRouteChildren {
  ExperimentsIdRouteRoute: typeof ExperimentsIdRouteRouteWithChildren
  ExperimentsIndexRoute: typeof ExperimentsIndexRoute
}

const ExperimentsRouteRouteChildren: ExperimentsRouteRouteChildren = {
  ExperimentsIdRouteRoute: ExperimentsIdRouteRouteWithChildren,
  ExperimentsIndexRoute: ExperimentsIndexRoute,
}

const ExperimentsRouteRouteWithChildren =
  ExperimentsRouteRoute._addFileChildren(ExperimentsRouteRouteChildren)

interface FigmaRouteRouteChildren {
  FigmaIndexRoute: typeof FigmaIndexRoute
}

const FigmaRouteRouteChildren: FigmaRouteRouteChildren = {
  FigmaIndexRoute: FigmaIndexRoute,
}

const FigmaRouteRouteWithChildren = FigmaRouteRoute._addFileChildren(
  FigmaRouteRouteChildren,
)

interface IntegrationsRouteRouteChildren {
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
}

const IntegrationsRouteRouteChildren: IntegrationsRouteRouteChildren = {
  IntegrationsIndexRoute: IntegrationsIndexRoute,
}

const IntegrationsRouteRouteWithChildren =
  IntegrationsRouteRoute._addFileChildren(IntegrationsRouteRouteChildren)

interface JobsRouteRouteChildren {
  JobsIndexRoute: typeof JobsIndexRoute
}

const JobsRouteRouteChildren: JobsRouteRouteChildren = {
  JobsIndexRoute: JobsIndexRoute,
}

const JobsRouteRouteWithChildren = JobsRouteRoute._addFileChildren(
  JobsRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsIndexRoute: typeof SettingsIndexRoute
  SettingsTeamIndexRoute: typeof SettingsTeamIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsTeamIndexRoute: SettingsTeamIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface SourceTemplatesRouteRouteChildren {
  SourceTemplatesIndexRoute: typeof SourceTemplatesIndexRoute
}

const SourceTemplatesRouteRouteChildren: SourceTemplatesRouteRouteChildren = {
  SourceTemplatesIndexRoute: SourceTemplatesIndexRoute,
}

const SourceTemplatesRouteRouteWithChildren =
  SourceTemplatesRouteRoute._addFileChildren(SourceTemplatesRouteRouteChildren)

interface WarehouseFeaturesRouteRouteChildren {
  WarehouseFeaturesFeatureIdLazyRoute: typeof WarehouseFeaturesFeatureIdLazyRoute
  WarehouseFeaturesNewLazyRoute: typeof WarehouseFeaturesNewLazyRoute
  WarehouseFeaturesIndexRoute: typeof WarehouseFeaturesIndexRoute
}

const WarehouseFeaturesRouteRouteChildren: WarehouseFeaturesRouteRouteChildren =
  {
    WarehouseFeaturesFeatureIdLazyRoute: WarehouseFeaturesFeatureIdLazyRoute,
    WarehouseFeaturesNewLazyRoute: WarehouseFeaturesNewLazyRoute,
    WarehouseFeaturesIndexRoute: WarehouseFeaturesIndexRoute,
  }

const WarehouseFeaturesRouteRouteWithChildren =
  WarehouseFeaturesRouteRoute._addFileChildren(
    WarehouseFeaturesRouteRouteChildren,
  )

interface WarehouseIdTypesRouteRouteChildren {
  WarehouseIdTypesIdTypeIdLazyRoute: typeof WarehouseIdTypesIdTypeIdLazyRoute
  WarehouseIdTypesNewLazyRoute: typeof WarehouseIdTypesNewLazyRoute
  WarehouseIdTypesIndexRoute: typeof WarehouseIdTypesIndexRoute
}

const WarehouseIdTypesRouteRouteChildren: WarehouseIdTypesRouteRouteChildren = {
  WarehouseIdTypesIdTypeIdLazyRoute: WarehouseIdTypesIdTypeIdLazyRoute,
  WarehouseIdTypesNewLazyRoute: WarehouseIdTypesNewLazyRoute,
  WarehouseIdTypesIndexRoute: WarehouseIdTypesIndexRoute,
}

const WarehouseIdTypesRouteRouteWithChildren =
  WarehouseIdTypesRouteRoute._addFileChildren(
    WarehouseIdTypesRouteRouteChildren,
  )

interface WarehouseMetricsRouteRouteChildren {
  WarehouseMetricsMetricIdLazyRoute: typeof WarehouseMetricsMetricIdLazyRoute
  WarehouseMetricsNewLazyRoute: typeof WarehouseMetricsNewLazyRoute
  WarehouseMetricsIndexRoute: typeof WarehouseMetricsIndexRoute
}

const WarehouseMetricsRouteRouteChildren: WarehouseMetricsRouteRouteChildren = {
  WarehouseMetricsMetricIdLazyRoute: WarehouseMetricsMetricIdLazyRoute,
  WarehouseMetricsNewLazyRoute: WarehouseMetricsNewLazyRoute,
  WarehouseMetricsIndexRoute: WarehouseMetricsIndexRoute,
}

const WarehouseMetricsRouteRouteWithChildren =
  WarehouseMetricsRouteRoute._addFileChildren(
    WarehouseMetricsRouteRouteChildren,
  )

interface WarehouseOverviewRouteRouteChildren {
  WarehouseOverviewIndexRoute: typeof WarehouseOverviewIndexRoute
}

const WarehouseOverviewRouteRouteChildren: WarehouseOverviewRouteRouteChildren =
  {
    WarehouseOverviewIndexRoute: WarehouseOverviewIndexRoute,
  }

const WarehouseOverviewRouteRouteWithChildren =
  WarehouseOverviewRouteRoute._addFileChildren(
    WarehouseOverviewRouteRouteChildren,
  )

interface WarehouseSourceTablesRouteRouteChildren {
  WarehouseSourceTablesSourceTableIdLazyRoute: typeof WarehouseSourceTablesSourceTableIdLazyRoute
  WarehouseSourceTablesNewLazyRoute: typeof WarehouseSourceTablesNewLazyRoute
  WarehouseSourceTablesIndexRoute: typeof WarehouseSourceTablesIndexRoute
}

const WarehouseSourceTablesRouteRouteChildren: WarehouseSourceTablesRouteRouteChildren =
  {
    WarehouseSourceTablesSourceTableIdLazyRoute:
      WarehouseSourceTablesSourceTableIdLazyRoute,
    WarehouseSourceTablesNewLazyRoute: WarehouseSourceTablesNewLazyRoute,
    WarehouseSourceTablesIndexRoute: WarehouseSourceTablesIndexRoute,
  }

const WarehouseSourceTablesRouteRouteWithChildren =
  WarehouseSourceTablesRouteRoute._addFileChildren(
    WarehouseSourceTablesRouteRouteChildren,
  )

interface WarehouseRouteRouteChildren {
  WarehouseFeaturesRouteRoute: typeof WarehouseFeaturesRouteRouteWithChildren
  WarehouseIdTypesRouteRoute: typeof WarehouseIdTypesRouteRouteWithChildren
  WarehouseMetricsRouteRoute: typeof WarehouseMetricsRouteRouteWithChildren
  WarehouseOverviewRouteRoute: typeof WarehouseOverviewRouteRouteWithChildren
  WarehouseSourceTablesRouteRoute: typeof WarehouseSourceTablesRouteRouteWithChildren
  WarehouseIndexRoute: typeof WarehouseIndexRoute
}

const WarehouseRouteRouteChildren: WarehouseRouteRouteChildren = {
  WarehouseFeaturesRouteRoute: WarehouseFeaturesRouteRouteWithChildren,
  WarehouseIdTypesRouteRoute: WarehouseIdTypesRouteRouteWithChildren,
  WarehouseMetricsRouteRoute: WarehouseMetricsRouteRouteWithChildren,
  WarehouseOverviewRouteRoute: WarehouseOverviewRouteRouteWithChildren,
  WarehouseSourceTablesRouteRoute: WarehouseSourceTablesRouteRouteWithChildren,
  WarehouseIndexRoute: WarehouseIndexRoute,
}

const WarehouseRouteRouteWithChildren = WarehouseRouteRoute._addFileChildren(
  WarehouseRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentsRouteRoute: AgentsRouteRouteWithChildren,
  ApiKeysRouteRoute: ApiKeysRouteRouteWithChildren,
  ContentRouteRoute: ContentRouteRouteWithChildren,
  DraftExperimentsRouteRoute: DraftExperimentsRouteRouteWithChildren,
  ExperimentsRouteRoute: ExperimentsRouteRouteWithChildren,
  FigmaRouteRoute: FigmaRouteRouteWithChildren,
  IntegrationsRouteRoute: IntegrationsRouteRouteWithChildren,
  JobsRouteRoute: JobsRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  SourceTemplatesRouteRoute: SourceTemplatesRouteRouteWithChildren,
  WarehouseRouteRoute: WarehouseRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
